import LangKeys from "./keys";

const ta = {
  [LangKeys.reminders_collect_faster]: "3 மடங்கு வேகமாக பணத்தை வசூலிக்கவும்",
  [LangKeys.reminders_total_dues]: "மொத்த நிலுவை",
  [LangKeys.reminders_all_customers]: "அனைத்து வாடிக்கையாளர்கள்",
  [LangKeys.reminders_all]: "அனைத்தும்",
  [LangKeys.reminders_customers]: "வாடிக்கையாளர்கள்",
  [LangKeys.reminders_suppliers]: "வழங்குநர்கள்",
  [LangKeys.reminders_search_placeholder]: "வாடிக்கையாளர் பெயர் அல்லது மொபைல் எண்ணைத் தேடவும்...",
  [LangKeys.reminders_pending_balance]: "நிலுவைத் தொகை",
  [LangKeys.reminders_sent]: "அனுப்பப்பட்டது",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "அழைக்கவும்",
  [LangKeys.reminders_date]: "தேதி",
  [LangKeys.reminders_all_up_to_date]: "அனைத்தும் புதுப்பிக்கப்பட்டது",
  [LangKeys.reminders_no_overdue_heading]: "காலாவதியான வாடிக்கையாளர்கள் யாரும் இல்லை",
  [LangKeys.reminders_no_overdue_sub]: "அற்புதம்! அனைத்து வாடிக்கையாளர் நிலுவைகளும் சரியான நேரத்தில் உள்ளன.",
  [LangKeys.reminders_view_all_customers]: "அனைத்து வாடிக்கையாளர்களைப் பார்க்கவும்",
  [LangKeys.reminders_no_due_today_heading]: "இன்று செலுத்த வேண்டிய வாடிக்கையாளர்கள் இல்லை",
  [LangKeys.reminders_no_due_today_sub]: "இன்றைய தேதிக்கு எந்த நினைவூட்டலும் திட்டமிடப்படவில்லை.",
  [LangKeys.reminders_no_upcoming_heading]: "வரவிருக்கும் நினைவூட்டல்கள் எதுவும் இல்லை",
  [LangKeys.reminders_no_upcoming_sub]: "தானியங்கி நினைவூட்டல்களை அனுப்ப வசூல் தேதியை அமைக்கவும்.",
  [LangKeys.reminders_no_customers_found]: "வாடிக்கையாளர்கள் யாரும் கிடைக்கவில்லை",
  [LangKeys.reminders_no_customers_matched]: "உங்கள் தேடலுக்கு ஏற்ற வாடிக்கையாளர்கள் இல்லை.",
  [LangKeys.reminders_auto_reminder_active]: "தானியங்கி நினைவூட்டல் செயலில் உள்ளது",
  [LangKeys.reminders_overdue_by]: "காலதாமதம்",
  [LangKeys.reminders_due_in]: "மீதமுள்ள நாட்கள்",
  [LangKeys.reminders_days]: "நாட்கள்",
  [LangKeys.reminders_day]: "நாள்",
  [LangKeys.reminders_set_collection_date]: "வசூல் தேதியை அமைக்கவும்",
  [LangKeys.reminders_collect_faster_sub]: "வாடிக்கையாளர்களிடமிருந்து விரைவாக வசூலிக்கவும்",
  [LangKeys.reminders_pending_amount_filter]: "நிலுவைத் தொகை வடிகட்டி (₹)",
  [LangKeys.reminders_highest_amount]: "அதிகபட்ச தொகை",
  [LangKeys.reminders_oldest_dues]: "பழைய நிலுவைகள்",
  [LangKeys.reminders_by_due_date]: "கெடு தேதிப்படி",
  [LangKeys.reminders_min]: "குறைந்தபட்சம்",
  [LangKeys.reminders_max]: "அதிகபட்சம்",
  [LangKeys.reminders_to]: "முதல்",
  [LangKeys.reminders_customers_selected]: "வாடிக்கையாளர்கள் தேர்ந்தெடுக்கப்பட்டனர்",
  [LangKeys.reminders_total]: "மொத்தம்",
  [LangKeys.reminders_set_due_date_selected]: "தேர்ந்தெடுக்கப்பட்டவர்களுக்கு தேதியை அமைக்கவும்",
  [LangKeys.reminders_date_lbl]: "தேதி",
  [LangKeys.reminders_wa_sent_toast]: "{name}க்கு WhatsApp நினைவூட்டல் அனுப்பப்பட்டது!",
  [LangKeys.reminders_date_updated]: "நினைவூட்டல் தேதி வெற்றிகரமாக சேமிக்கப்பட்டது!",

  [LangKeys.reminders_bulk_success]: "நினைவூட்டல் வெற்றிகரமாக அனுப்பப்பட்டது!",

  [LangKeys.reminders_sending]: "சேமிக்கப்படுகிறது...",

  [LangKeys.reminders_cloud_wa]: "கிளவுட் WhatsApp API",

  [LangKeys.reminders_direct_wa]: "நேரடி WhatsApp (இலவச வலை/செயலி)",

  [LangKeys.reminders_no_pending_desc]: "வாடிக்கையாளரிடமிருந்து பணம் பெற வேண்டியிருக்கும் போது, அவர்கள் இங்கே நினைவூட்டல் பட்டியலில் தோன்றுவார்கள்.",

  [LangKeys.reminders_no_pending]: "நிலுவையில் உள்ள நினைவூட்டல்கள் எதுவும் இல்லை",

  [LangKeys.reminders_clear_date]: "தேதியை அழிக்கவும்",

  [LangKeys.reminders_save_date]: "தேதியைச் சேமிக்கவும்",

  [LangKeys.reminders_time_lbl]: "நேரம்",

  [LangKeys.reminders_chip_custom]: "தனிப்பயன் தேதி",

  [LangKeys.reminders_chip_1month]: "1 மாதத்திற்குப் பிறகு",

  [LangKeys.reminders_chip_15days]: "15 நாட்களுக்குப் பிறகு",

  [LangKeys.reminders_chip_1week]: "1 வாரத்திற்குப் பிறகு",

  [LangKeys.reminders_chip_3days]: "3 நாட்களுக்குப் பிறகு",

  [LangKeys.reminders_chip_tomorrow]: "நாளை",

  [LangKeys.reminders_chip_today]: "இன்று",

  [LangKeys.reminders_days_left]: "நாட்கள் மீதம்",

  [LangKeys.reminders_days_overdue]: "நாட்கள் தாமதம்",

  [LangKeys.reminders_not_sent]: "இன்னும் அனுப்பப்படவில்லை",

  [LangKeys.reminders_last_sent]: "கடைசியாக அனுப்பப்பட்டது",

  [LangKeys.reminders_auto_reminder_desc]: "திட்டமிடப்பட்ட தேதி மற்றும் நேரத்தில் தானாக நினைவூட்டல் அனுப்பவும்",

  [LangKeys.reminders_auto_reminder]: "தானியங்கி நினைவூட்டல் (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "அனைவருக்கும் ஒரே நேரத்தில் வாட்ஸ்அப் அனுப்பவும்",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp நினைவூட்டலை அனுப்பவும்",

  [LangKeys.reminders_change_due_date]: "தேதியை மாற்றவும்",

  [LangKeys.reminders_set_due_date]: "கெடு தேதியை அமைக்கவும்",

  [LangKeys.reminders_selected]: "தேர்ந்தெடுக்கப்பட்டது",

  [LangKeys.reminders_select_all]: "அனைத்தையும் தேர்ந்தெடு",

  [LangKeys.reminders_search_hint]: "வாடிக்கையாளர் பெயர் அல்லது மொபைலைத் தேடுங்கள்...",

  [LangKeys.reminders_no_date_tab]: "தேதி இல்லை",

  [LangKeys.reminders_upcoming_tab]: "வரவிருப்பவை",

  [LangKeys.reminders_overdue_tab]: "ஓவர்டியூ",

  [LangKeys.reminders_today_tab]: "இன்று",

  [LangKeys.reminders_all_tab]: "அனைத்தும்",

  [LangKeys.reminders_no_date]: "தேதி அமைக்கப்படவில்லை",

  [LangKeys.reminders_upcoming]: "வரவிருப்பவை",

  [LangKeys.reminders_due_today]: "இன்று செலுத்த வேண்டியவை",

  [LangKeys.reminders_overdue]: "காலாவதியானது",

  [LangKeys.reminders_total_outstanding]: "மொத்த நிலுவைத்தொகை",

  [LangKeys.reminders_subtitle]: "ஸ்மார்ட் கணக்குப்பதிவு மூலம் உங்கள் வணிகத்தை வளர்க்கவும்.",

  [LangKeys.reminders_title]: "பணம் செலுத்தும் நினைவூட்டல்",

  [LangKeys.processing]: "செயலாக்கத்தில் உள்ளது...",

  [LangKeys.business_owner]: "வணிக உரிமையாளர்",

  [LangKeys.moxpal_khata]: "மோக்ஸ்பால் கட்டா",

  [LangKeys.failed_load_dashboard]: "டாஷ்போர்டு தரவை ஏற்றுவதில் தோல்வி",

  [LangKeys.delete_confirm]: "நிச்சயமாக நீக்க விரும்புகிறீர்களா?",

  [LangKeys.today]: "இன்று",

  [LangKeys.add_bill_terms_conditions_hint]: "விதிமுறைகள் மற்றும் நிபந்தனைகள்...",

  [LangKeys.stock]: "சரக்கு இருப்பு",

  [LangKeys.add_bill_item_price]: "விலை",

  [LangKeys.add_bill_item_name]: "பொருளின் பெயர்",

  [LangKeys.parties]: "பார்ட்டிகள்",

  [LangKeys.address_area]: "பகுதி / முக்கிய அடையாளம்",

  [LangKeys.address_flat_no]: "பிளாட் / கட்டிட எண்",

  [LangKeys.search_items_hint]: "பொருட்களைத் தேடுங்கள்...",

  [LangKeys.no_items_found]: "பொருட்கள் எதுவும் கிடைக்கவில்லை",

  [LangKeys.loading]: "ஏற்றுகிறது...",

  [LangKeys.edit_price_dialog_title]: "விலையை திருத்து",

  [LangKeys.photos]: "புகைப்படங்கள்",

  [LangKeys.notes]: "குறிப்புகள்",

  [LangKeys.save_expense]: "செலவை சேமிக்கவும்",

  [LangKeys.add_bill_payment_details]: "கட்டண விவரங்கள்",

  [LangKeys.fields]: "புலங்கள்",

  [LangKeys.unpaid]: "செலுத்தப்படாதது (Unpaid)",

  [LangKeys.item_name_required]: "பொருளின் பெயர் தேவை",

  [LangKeys.delete_confirmation]: "நிச்சயமாக இதை நீக்க விரும்புகிறீர்களா?",

  [LangKeys.online_private]: "தனிப்பட்டது (Private)",

  [LangKeys.online_active]: "ஆன்லைன் சந்தையில் உள்ளது",

    [LangKeys.app_name]: 'மோக்ஷ்பால் கணக்கு',
    [LangKeys.header_subtitle]: "ஸ்மார்ட் புக் கீப்பிங்குடன் உங்கள் வணிகத்தை வளர்த்துக் கொள்ளுங்கள்.",

    // SHARED KHATA
    [LangKeys.shared_khata__summary]: 'கணக்கு சுருக்கம்',
    [LangKeys.customer_name]: 'வாடிக்கையாளர் பெயர்',
    [LangKeys.mobile_no]: 'மொபைல் எண்',
    [LangKeys.transaction_history]: 'பரிவர்த்தனை வரலாறு',
    [LangKeys.total_debit]: 'மொத்த டெபிட்',
    [LangKeys.total_credit]: 'மொத்த கிரெடிட்',
    [LangKeys.net_balance]: 'நிகர இருப்பு',
    [LangKeys.date]: 'தேதி',
    [LangKeys.credit]: 'கடன்',
    [LangKeys.debit]: 'பற்று',
    [LangKeys.balance]: 'இருப்பு',
    [LangKeys.note]: 'குறிப்பு',
    [LangKeys.call_support]: 'ஆதரவை அழைக்கவும்',
    [LangKeys.invalid_link]: 'இந்த இணைப்பு செல்லாதது அல்லது காலாவதியாகிவிட்டது.',
    [LangKeys.footer]: 'இது கணினியால் உருவாக்கப்பட்ட அறிக்கை மற்றும் இதற்கு எந்த கையொப்பமும் தேவையில்லை.',

    // COMMON
    [LangKeys.settings]: 'அமைப்புகள்',
    [LangKeys.settings_subtitle]: 'உங்கள் பயன்பாடு மற்றும் வணிக விருப்பங்களை நிர்வகிக்கவும்',
    [LangKeys.language]: 'மொழி',
    [LangKeys.select_language]: 'மொழியைத் தேர்ந்தெடுக்கவும்',
    [LangKeys.close]: 'மூடு',
    [LangKeys.save]: 'சேமி',
    [LangKeys.retry]: 'மீண்டும் முயற்சிக்கவும்',
    [LangKeys.profile]: 'சுயவிவரத்தை திருத்தவும்',
    [LangKeys.logout]: 'வெளியேறு',
    [LangKeys.version]: 'பதிப்பு',
    [LangKeys.copyright]: 'பதிப்புரிமை © மோக்ஸ்பால் கட்டா',
    [LangKeys.total]: "மொத்தம்",
    [LangKeys.required_field]: "இந்த புலம் அவசியம்",
    [LangKeys.product]: "தயாரிப்பு",

    [LangKeys.message_language]: "SMS மொழி",
    [LangKeys.follow_app]: "ஆப்பை பின்பற்று",

    [LangKeys.hindi]: "இந்தி",
    [LangKeys.english]: "ஆங்கிலம்",
    [LangKeys.hinglish]: "ஹிங்லிஷ்",

    [LangKeys.gujarati]: "குஜராத்தி",
    [LangKeys.marathi]: "மராத்தி",
    [LangKeys.punjabi]: "பஞ்சாபி",
    [LangKeys.tamil]: "தமிழ்",
    [LangKeys.telugu]: "தெலுங்கு",

    // SETTINGS PAGE
    [LangKeys.business_settings]: 'வணிக அமைப்புகள்',
    [LangKeys.business_settings_desc]: 'வணிக சுயவிவரம், லோகோ மற்றும் ஜிஎஸ்டி விவரங்கள்',
    [LangKeys.staff_permissions]: 'பணியாளர்கள் மற்றும் அனுமதிகள்',
    [LangKeys.staff_permissions_desc]: 'பணியாளர் அணுகல் மற்றும் அனுமதிகளை நிர்வகிக்கவும்',
    [LangKeys.backup_information]: 'காப்புத் தகவல்',
    [LangKeys.backup_information_desc]: 'கணக்குத் தரவை ஏற்றுமதி செய்து மீட்டெடுக்கவும்',
    [LangKeys.delete_khata]: 'கணக்கை நீக்கு',
    [LangKeys.delete_khata_desc]: 'அனைத்து வணிகத் தரவையும் நிரந்தரமாக அகற்றவும்',
    [LangKeys.app_update]: 'பயன்பாட்டுப் புதுப்பிப்பு',
    [LangKeys.app_update_desc]: 'சமீபத்திய பதிப்பிற்காகச் சரிபார்க்கவும்',
    [LangKeys.app_up_to_date]: "அப் சமீபத்திய பதிப்பில் உள்ளது",
    [LangKeys.failed_to_check_for_update]: "புதுப்பிப்பை சரிபார்க்க முடியவில்லை",
    [LangKeys.whatsapp_service]: "வாட்ஸ்அப் அலர்ட்ஸ் & கிரெடிட்ஸ்",
    [LangKeys.whatsapp_service_desc]: "வாடிக்கையாளர்களுக்கு தானாக பணம் நினைவூட்டலை அனுப்பி கிரெடிட்ஸை நிர்வகிக்கவும்",

    /* ================= Whatsapp SMS Credtits PAGE ================= */
    [LangKeys.whatsapp_credits]: 'வாட்ஸ்அப் கிரெடிட்ஸ்',
    [LangKeys.available_credits]: 'கிடைக்கும் கிரெடிட்ஸ்',
    [LangKeys.whatsapp_balance]: 'வாட்ஸ்அப் செய்தி இருப்பு',
    [LangKeys.used]: 'பயன்படுத்தியது',
    [LangKeys.credits]: 'கிரெடிட்ஸ்',
    [LangKeys.proceed_to_pay]: 'பணம் செலுத்தவும்',
    [LangKeys.recharge_plans]: 'ரீசார்ஜ் திட்டங்கள்',
    [LangKeys.off]: 'ஆஃப்',

    [LangKeys.load_failed]: 'லோடு தோல்வியடைந்தது',
    [LangKeys.toggle_failed]: 'டாகிள் தோல்வியடைந்தது',
    [LangKeys.order_failed]: 'ஆர்டர் தோல்வியடைந்தது',
    [LangKeys.payment_error]: 'பணம் செலுத்தலில் பிழை',
    [LangKeys.payment_failed]: 'பணம் செலுத்தல் தோல்வியடைந்தது',
    [LangKeys.verification_failed]: 'சரிபார்ப்பு தோல்வியடைந்தது',
    [LangKeys.recharge_successful]: 'ரீசார்ஜ் வெற்றிகரமாக முடிந்தது',
    [LangKeys.total_purchased]: 'மொத்தமாக வாங்கப்பட்டது',
    [LangKeys.premium_unlimited_active]: "வரம்பற்ற WhatsApp அலர்ட்கள் செயல்பாட்டில் உள்ளன! 🎉",
    [LangKeys.premium_unlimited_desc]: "நீங்கள் Moxpal Khata இன் சிறந்த 'Premium Plan' இன் செயலில் உள்ள உறுப்பினராக இருக்கிறீர்கள்! உங்களுக்கு வரம்பற்ற ஆட்டோ WhatsApp மற்றும் SMS அலர்ட்கள் முற்றிலும் இலவசமாக வழங்கப்பட்டுள்ளன.",

    /* ================= BACKUP INFORMATION ================= */
    [LangKeys.backup_info_text]: 'உங்கள் தொலைபேசி இணையத்துடன் இணைக்கப்படும்போது உங்கள் தரவு தானாகவே காப்புப் பிரதி எடுக்கப்படுகிறது. உங்கள் தொலைபேசியை வடிவமைத்தால் அல்லது பயன்பாட்டை நீக்கினால், உங்கள் பதிவு செய்யப்பட்ட எண்ணைப் பயன்படுத்தி மீண்டும் உள்நுழையவும். உங்கள் தரவு தானாகவே மீட்டெடுக்கப்படும்.',
    [LangKeys.last_backup_at]: 'கடைசி காப்புப் பிரதி',

    /* ================= DELETE / KHATA ================= */
    [LangKeys.delete_warning_text]: 'நீங்கள் இந்த வணிகத்தை நீக்கப் போகிறீர்கள். உங்கள் எல்லா தரவுகளும் மறுசுழற்சி தொட்டிக்கு நகர்த்தப்படும். நீங்கள் அதை 30 நாட்களுக்குள் மீட்டெடுக்கலாம்.',
    [LangKeys.delete_placeholder]: 'உறுதிப்படுத்த வணிகப் பெயரைத் தட்டச்சு செய்யவும்',
    [LangKeys.delete_button]: 'நீக்கு',
    [LangKeys.delete_name_mismatch]: 'வணிகப் பெயர் பொருந்தவில்லை.',

    // ================= KHATA =================
    [LangKeys.my_khata]: "என் கணக்கு",
    [LangKeys.search_customer]: "வாடிக்கையாளரை தேடுங்கள்",
    [LangKeys.all_customers]: "அனைத்து வாடிக்கையாளர்கள்",
    [LangKeys.no_customers_found]: "வாடிக்கையாளர்கள் எவரும் இல்லை",
    [LangKeys.no_suppliers_found]: "சப்ளையர்கள் எவரும் இல்லை",
    [LangKeys.no_parties_found]: "எந்த தரப்புகளும் கிடைக்கவில்லை",

    [LangKeys.just_now]: 'இப்போதுதான்',
    [LangKeys.min_ago]: '{value} நிமிடங்களுக்கு முன்',
    [LangKeys.hr_ago]: '{value} மணி நேரங்களுக்கு முன்',
    [LangKeys.day_ago]: '{value} நாட்களுக்கு முன்',
    [LangKeys.month_ago]: '{value} மாதங்களுக்கு முன்',
    [LangKeys.year_ago]: '{value} ஆண்டுகளுக்கு முன்',

    [LangKeys.settled]: 'கணக்கு சரி',
    [LangKeys.advance]: 'ஜமா தொகை',
    [LangKeys.due]: 'கடன்',
    [LangKeys.no_transactions]: 'பரிவர்த்தனை இல்லை',
    [LangKeys.no_entries_yet]: 'இன்னும் எந்த பதிவு இல்லை',
    [LangKeys.new_label]: 'புதியது',

    /* ================= DASHBOARD / HOME SCREEN ================= */
    [LangKeys.khata]: 'கணக்கு',
    [LangKeys.you_will_get]: 'நீங்கள் பெறுவீர்கள்',
    [LangKeys.you_will_give]: 'நீங்கள் கொடுப்பீர்கள்',
    [LangKeys.search_khata_entry]: 'கணக்குப் பதிவைத் தேடு',
    [LangKeys.recent_entries]: 'சமீபத்திய பதிவுகள்',
    [LangKeys.unknown_party]: 'தெரியாத கட்சி',
    [LangKeys.unknown_customer]: 'தெரியாத வாடிக்கையாளர்',
    [LangKeys.unknown]: 'தெரியாத',

    // CUSTOMER LEDGER
    [LangKeys.ledger]: 'பேரேடு',
    [LangKeys.report]: 'அறிக்கை',
    [LangKeys.reminder]: 'நினைவூட்டல்',
    [LangKeys.sms]: 'எஸ்எம்எஸ்',
    [LangKeys.whatsapp]: 'வாட்ஸ்அப்',
    [LangKeys.outstanding_balance]: "நிலுவை தொகை",
    [LangKeys.total_balance]: 'மொத்த இருப்பு',
    [LangKeys.you_got]: 'நீங்கள் பெற்றீர்கள்',
    [LangKeys.you_gave]: 'நீங்கள் கொடுத்தீர்கள்',
    [LangKeys.entries]: 'பதிவுகள்',
    [LangKeys.no_entries_found]: 'பதிவுகள் இல்லை',
    [LangKeys.i_got]: 'நான் பெற்றேன்',
    [LangKeys.i_gave]: 'நான் கொடுத்தேன்',
    [LangKeys.you_got_caps]: 'நீங்கள் பெற்றீர்கள்',
    [LangKeys.you_gave_caps]: 'நீங்கள் கொடுத்தீர்கள்',
    [LangKeys.wa_dear]: 'அன்புள்ள',
    [LangKeys.wa_account_update]: 'மோக்ஷ்பால் கணக்கிலிருந்து உங்கள் கணக்கு புதுப்பிப்பு இங்கே உள்ளது.',
    [LangKeys.total_due]: "மொத்த நிலுவை தொகை",
    [LangKeys.view_full_account]: 'முழு கணக்கு அறிக்கையைப் பார்க்கவும்',
    [LangKeys.failed_to_load_data]: 'தரவை ஏற்றுவதில் தோல்வி.',
    [LangKeys.could_not_open_whatsapp]: 'வாட்ஸ்அப்பைத் திறக்க முடியவில்லை.',
    [LangKeys.could_not_open_sms]: 'SMS பயன்பாட்டைத் திறக்க முடியவில்லை.',
    [LangKeys.total_purchase]: "மொத்த கொள்முதல்",
    [LangKeys.total_received]: "மொத்தம் பெறப்பட்ட",

    [LangKeys.entry_success]: 'பதிவு வெற்றிகரமாக முடிந்தது',
    [LangKeys.transaction_success]: 'பரிவர்த்தனை வெற்றிகரமாக முடிந்தது',
    [LangKeys.done]: 'முடிந்தது',

    // ENTRY
    [LangKeys.entry_details]: 'பதிவு விவரங்கள்',
    [LangKeys.running_balance]: 'இயங்கும் இருப்பு',
    [LangKeys.share]: 'பகிர்',
    [LangKeys.network_error]: 'நெட்வொர்க் பிழை',
    [LangKeys.copy_link]: 'இணைப்பை நகலெடு',
    [LangKeys.delete_entry]: 'பதிவை நீக்கு',
    [LangKeys.delete_entry_confirm]: 'இந்தப் பதிவை நீக்க விரும்புகிறீர்களா?',
    [LangKeys.delete_entry_warning]: 'இந்தச் செயலைச் செயல்தவிர்க்க முடியாது.',
    [LangKeys.edit_entry]: 'பதிவைத் திருத்து',
    [LangKeys.invalid_entry]: 'செல்லாத பதிவு',
    [LangKeys.entry_not_found]: 'பதிவு கிடைக்கவில்லை',
    [LangKeys.invalid_entry_type]: 'செல்லாத பதிவு வகை',
    [LangKeys.invalid_amount]: 'செல்லாத தொகை',
    [LangKeys.invalid_date]: 'செல்லாத தேதி',
    [LangKeys.photo_size_error]: 'புகைப்பட அளவு 1MB க்கும் குறைவாக இருக்க வேண்டும்',
    [LangKeys.invalid_image_format]: 'இந்த படம் வடிவம் ஆதரிக்கப்படவில்லை. தயவுசெய்து JPG, PNG அல்லது WEBP படத்தை தேர்வு செய்யவும்.',
    [LangKeys.photo_upload_failed]: 'புகைப்படப் பதிவேற்றம் தோல்வியடைந்தது',
    [LangKeys.update_failed]: 'புதுப்பித்தல் தோல்வியடைந்தது',
    [LangKeys.amount]: 'தொகை',
    [LangKeys.photo_max]: 'புகைப்படம் (அதிகபட்சம் 1MB)',
    [LangKeys.change_photo]: 'புகைப்படத்தை மாற்று',
    [LangKeys.add_entry_title]: 'பதிவைச் சேர்',
    [LangKeys.save_entry]: 'பதிவைச் சேமி',
    [LangKeys.photo]: 'புகைப்படம்',
    [LangKeys.amount_hint]: '₹ 0',
    [LangKeys.note_hint]: 'விருப்பக் குறிப்பு',
    [LangKeys.add_photo_label]: '📷 புகைப்படத்தைச் சேர்',
    [LangKeys.failed_to_add_entry]: 'பதிவைச் சேர்ப்பதில் தோல்வி.',
    [LangKeys.image_too_large_4mb]: 'படம் மிகப் பெரியது. தயவுசெய்து 4MB க்கு கீழ் உள்ள படத்தைத் தேர்ந்தெடுக்கவும்.',
    [LangKeys.share_coming_soon]: 'பகிர்வு அம்சம் விரைவில் வருகிறது!',
    [LangKeys.image_load_failed]: 'படத்தை ஏற்றுவதில் தோல்வி',
    [LangKeys.select_date]: 'தேதியைத் தேர்ந்தெடுக்கவும்',
    [LangKeys.photo_max_2mb]: 'புகைப்படம் (அதிகபட்சம் 2MB)',
    [LangKeys.add_to_cashbook]: "கேஷ்புக்கிலும் சேர்க்கவும்",

    [LangKeys.owner_name]: 'உரிமையாளர் பெயர்',
    [LangKeys.customer_ledger_statement]: 'வாடிக்கையாளர் பேரேடு அறிக்கை',
    [LangKeys.phone]: 'தொலைபேசி',
    [LangKeys.opening_balance]: 'தொடக்க இருப்பு',
    [LangKeys.closing_balance]: 'இறுதி இருப்பு',
    [LangKeys.transaction_details]: 'பரிவர்த்தனை விவரங்கள்',
    [LangKeys.particulars]: 'விவரங்கள்',
    [LangKeys.credit_short]: 'கிரா',
    [LangKeys.debit_short]: 'டெபி',
    [LangKeys.generated_by]: 'மோக்ஷ்பால் கணக்கினால் உருவாக்கப்பட்டது',
    [LangKeys.my_business]: 'எனது வணிகம்',
    [LangKeys.pdf_generation_error]: 'PDF உருவாக்குவதில் பிழை',
    [LangKeys.debit_minus]: 'பற்று (-)',
    [LangKeys.credit_plus]: 'கடன் (+)',
    [LangKeys.total_paid]: "மொத்தமாக செலுத்திய தொகை",
    [LangKeys.received]: 'பெறப்பட்டது',
    [LangKeys.paid]: "செலுத்தியது",
    [LangKeys.supplier_name]: "சப்ளையர் பெயர்",
    [LangKeys.supplier_report]: "சப்ளையர் அறிக்கை",
    [LangKeys.supplier_ledger_statement]: "சப்ளையர் லெட்ஜர் அறிக்கை",
    [LangKeys.data_not_available_for_pdf]: "PDFக்கான தரவு கிடைக்கவில்லை",

    // ACCOUNT
    [LangKeys.account]: 'கணக்கு',
    [LangKeys.add_business]: 'வணிக விவரங்களைச் சேர்',
    [LangKeys.add_owner]: 'உரிமையாளர் விவரங்களைச் சேர்',
    [LangKeys.business]: 'வணிகம்',
    [LangKeys.staff]: 'பணியாளர்கள்',
    [LangKeys.items]: 'பொருட்கள்',
    [LangKeys.bills]: 'பில்கள்',
    [LangKeys.dairy]: "டெய்ரி",
    [LangKeys.cashbook]: 'பண புத்தகம்',
    [LangKeys.help_support]: 'உதவி மற்றும் ஆதரவு',
    [LangKeys.about_app]: 'எங்களைப் பற்றி',
    [LangKeys.invite_friends]: 'நண்பர்களை அழைக்கவும்',
    [LangKeys.privacy_policy]: 'தனியுரிமைக் கொள்கை',
    [LangKeys.disclaimer]: 'பொறுப்புத் துறப்பு',
    [LangKeys.share_subject]: "📒 மோக்ஸ்பால் காத்தா ஆப்",
    [LangKeys.share_message]: "👉 கடன் மற்றும் பரிவர்த்தனை கணக்குகளை பராமரிக்க நான் Moxpal Khata ஆப்பை பயன்படுத்துகிறேன். இது மிகவும் எளிமையானதும் நம்பகமானதும் ஆகும். 📲 நீங்கள் கூட இப்போது பதிவிறக்கம் செய்து உங்கள் கணக்குகளை எளிதாக நிர்வகிக்கலாம்: https://khata.moxpal.com/app",

    // STAFF
    [LangKeys.staff_details]: 'பணியாளர் விவரங்கள்',
    [LangKeys.staff_question]: 'பணியாளர் என்றால் என்ன?',
    [LangKeys.add_staff]: 'பணியாளரைச் சேர்',
    [LangKeys.staff_name]: 'பணியாளர் பெயர்',
    [LangKeys.permissions]: 'அனுமதிகள்',
    [LangKeys.stop_staff]: 'பணியாளரை நிறுத்து',
    [LangKeys.stop_staff_desc]: 'இந்த ஊழியர் உங்கள் வணிகத் தரவை அணுக முடியாது.',
    [LangKeys.delete_staff]: 'பணியாளரை நீக்கு',
    [LangKeys.delete_staff_desc]: 'இந்த ஊழியர் நிரந்தரமாக நீக்கப்படுவார்.',
    [LangKeys.add_staff_to_manage]: "மேலாண்மை செய்ய பணியாளர்களை சேர்க்கவும்",

    // NAVBAR
    [LangKeys.home]: 'முகப்பு',
    [LangKeys.more]: "மேலும்",

    // ADD PARTY
    [LangKeys.add_party]: 'கட்சியைச் சேர்',
    [LangKeys.address_optional]: 'முகவரி (விருப்பத்தேர்வு)',
    [LangKeys.gst_optional]: 'ஜிஎஸ்டிஐஎன் (விருப்பத்தேர்வு)',
    [LangKeys.add_supplier]: 'சப்ளையரைச் சேர்',
    [LangKeys.name_required]: 'பெயர் தேவை',
    [LangKeys.edit]: 'திருத்து',

    // BOOK PROFILE
    [LangKeys.book_profile]: 'கணக்கு சுயவிவரம் உருவாக்கவும்',
    [LangKeys.personal_info]: 'தனிப்பட்ட தகவல்',
    [LangKeys.business_info]: 'வணிகத் தகவல்',
    [LangKeys.financial_info]: 'நிதித் தகவல்',
    [LangKeys.staff_info]: 'பணியாளர் தகவல்',
    [LangKeys.name]: 'பெயர்',
    [LangKeys.add_name]: 'பெயரைச் சேர்',
    [LangKeys.registered_number]: 'பதிவு செய்யப்பட்ட மொபைல் எண்',
    [LangKeys.add_mobile]: 'மொபைல் எண்ணைச் சேர்',
    [LangKeys.business_name]: 'வணிகப் பெயர்',
    [LangKeys.business_address]: 'வணிக முகவரி',
    [LangKeys.add_address]: 'முகவரியைச் சேர்',
    [LangKeys.gstin]: 'ஜிஎஸ்டிஐஎன்',
    [LangKeys.bank_account]: 'வங்கி கணக்கு',
    [LangKeys.add_details]: 'விவரங்களைச் சேர்',
    [LangKeys.details]: 'விவரங்கள்',
    [LangKeys.add_photo]: "புகைப்படம் சேர்க்கவும்",
    [LangKeys.profile_strength]: "சுயவிவர வலிமை",
    [LangKeys.customer_profile]: "வாடிக்கையாளர் சுயவிவரம்",
    [LangKeys.supplier_profile]: "சப்ளையர் சுயவிவரம்",
    [LangKeys.address]: "முகவரி",
    [LangKeys.type]: "வகை",
    [LangKeys.customer]: "வாடிக்கையாளர்",
    [LangKeys.supplier]: "சப்ளையர்",
    [LangKeys.delete_customer]: "வாடிக்கையாளரை நீக்கவும்",
    [LangKeys.delete_supplier]: "சப்ளையரை நீக்கவும்",
    [LangKeys.delete_customer_desc]: "இந்த வாடிக்கையாளரை நீக்க விரும்புகிறீர்களா? தொடர்புடைய அனைத்து தரவுகளும் நீக்கப்படும்.",
    [LangKeys.delete_supplier_desc]: "இந்த சப்ளையரை நீக்க விரும்புகிறீர்களா? தொடர்புடைய அனைத்து தரவுகளும் நீக்கப்படும்.",
    [LangKeys.add_gstin]: "GSTIN சேர்க்கவும்",

    /* ================= SMS SETTINGS ================= */
    [LangKeys.sms_settings]: "SMS அமைப்புகள்",
    [LangKeys.sms_settings_desc]: "இந்த வாடிக்கையாளருக்கான மெசேஜ் அமைப்புகளை நிர்வகிக்கவும்",
    [LangKeys.edit_customer_details]: "வாடிக்கையாளர் விவரங்களை திருத்தவும்",
    [LangKeys.edit_customer_details_desc]: "இங்கே நீங்கள் பெயர், மொபைல், முகவரி மற்றும் GST விவரங்களை மாற்றலாம்.",

    // PROFILE STRENGTH
    [LangKeys.weak]: 'பலவீனமான',
    [LangKeys.average]: 'சராசரி',
    [LangKeys.good]: 'நல்ல',
    [LangKeys.strong]: 'வலுவான',

    // STAFF & PERMISSIONS
    [LangKeys.save_staff]: 'பணியாளரைச் சேமி',
    [LangKeys.update_staff]: 'பணியாளரைப் புதுப்பி',
    [LangKeys.cancel]: 'ரத்துசெய்',
    [LangKeys.no_staff_found]: 'பணியாளர்கள் இல்லை',
    [LangKeys.active]: 'செயலில்',
    [LangKeys.stopped]: 'நிறுத்தப்பட்டது',
    [LangKeys.start]: 'தொடங்கு',
    [LangKeys.stop]: 'நிறுத்து',
    [LangKeys.view]: 'பார்',
    [LangKeys.add]: 'சேர்',
    [LangKeys.delete]: 'நீக்கு',
    [LangKeys.mobile_number]: 'கைபேசி எண்',
    [LangKeys.add_staff_title]: 'பணியாளரைச் சேர்',
    [LangKeys.edit_staff_title]: 'பணியாளரைத் திருத்து',
    [LangKeys.staff_deleted_success]: 'ஊழியர் வெற்றிகரமாக நீக்கப்பட்டார்',
    [LangKeys.yes]: 'ஆம்',
    [LangKeys.no]: 'இல்லை',
    [LangKeys.khatabook_deleted_success]: 'கணக்கு புத்தகம் வெற்றிகரமாக நீக்கப்பட்டது',
    [LangKeys.something_went_wrong]: 'ஏதோ தவறு நடந்துவிட்டது',
    [LangKeys.business_logo]: 'வணிக லோகோ',
    [LangKeys.choose_photo]: 'புகைப்படத்தைத் தேர்ந்தெடு',
    [LangKeys.save_logo]: 'லோகோவைச் சேமி',
    [LangKeys.upload_error]: 'பதிவேற்றப் பிழை',
    [LangKeys.upload_type_err]: 'பதிவேற்ற வகை பிழை',
    [LangKeys.enter_name]: 'பெயரை உள்ளிடவும்',
    [LangKeys.enter_mobile]: 'மொபைலை உள்ளிடவும்',
    [LangKeys.enter_business]: 'வணிகத்தை உள்ளிடவும்',
    [LangKeys.enter_address]: 'முகவரியை உள்ளிடவும்',
    [LangKeys.gstin_details]: 'ஜிஎஸ்டிஐஎன் விவரங்கள்',
    [LangKeys.gstin_number]: 'ஜிஎஸ்டிஐஎன் எண்',
    [LangKeys.enter_gstin]: 'ஜிஎஸ்டிஐஎன் உள்ளிடவும்',
    [LangKeys.gstin_note]: 'உங்கள் ஜிஎஸ்டிஐஎன் உங்கள் வணிகத்தைச் சரிபார்க்கவும், இன்வாய்ஸ்களை உருவாக்கவும் பயன்படுகிறது.',
    [LangKeys.save_gstin]: 'ஜிஎஸ்டிஐஎன் சேமி',
    [LangKeys.bank_details]: 'வங்கி விவரங்கள்',
    [LangKeys.bank_name]: 'வங்கி பெயர்',
    [LangKeys.enter_bank_name]: 'வங்கி பெயரை உள்ளிடவும்',
    [LangKeys.account_number]: 'கணக்கு எண்',
    [LangKeys.enter_account_no]: 'கணக்கு எண்ணை உள்ளிடவும்',
    [LangKeys.ifsc_code]: 'ஐஎஃப்எஸ்சி குறியீடு',
    [LangKeys.enter_ifsc]: 'ஐஎஃப்எஸ்சி குறியீட்டை உள்ளிடவும்',
    [LangKeys.bank_note]: 'உங்கள் வங்கிக் கணக்கு பணம் பெறுவதற்குப் பயன்படுகிறது.',
    [LangKeys.save_bank_details]: 'வங்கி விவரங்களைச் சேமி',
    [LangKeys.invalid_bank_details]: 'செல்லாத வங்கி விவரங்கள்',
    [LangKeys.confirm]: 'உறுதிப்படுத்தவும்',
    [LangKeys.invalid_gstin]: 'செல்லாத ஜிஎஸ்டிஐஎன்',
    [LangKeys.failed_to_save]: 'சேமிக்கத் தவறிவிட்டது',

    // Cashbook
    [LangKeys.cash]: "பணம்",
    [LangKeys.online]: "புதியது",
    [LangKeys.total_balance_cashbook]: "மொத்த நிலுவை",
    [LangKeys.today_balance]: "இன்றைய இருப்பு",
    [LangKeys.view_report]: "அறிக்கையைப் பார்க்கவும்",
    [LangKeys.out_entry]: "வெளியே",
    [LangKeys.in_entry]: "உள்ளே",
    [LangKeys.add_first_entry]: "உங்கள் முதல் பதிவைச் சேர்க்கவும்",
    [LangKeys.attach_bill]: "பில்லை இணைக்கவும்",
    [LangKeys.enter_amount]: "தொகையை உள்ளிடவும்",
    [LangKeys.empty_title]: "இன்னும் பதிவுகள் இல்லை",
    [LangKeys.saving]: "சேமிக்கிறது...",
    [LangKeys.save_failed]: "சேமிக்கத் தவறிவிட்டது",
    [LangKeys.server_error]: "சேவையகப் பிழை",
    [LangKeys.ok]: "சரி",
    [LangKeys.error]: "பிழை",
    [LangKeys.payment_mode]: "பணம் செலுத்தும் முறை",
    [LangKeys.entry_saved_offline_and_will_be_synced_later]: "பதிவு ஆஃப்லைனில் சேமிக்கப்பட்டது. இணையம் கிடைத்ததும் ஒத்திசைக்கப்படும்",
    [LangKeys.entry_waiting_to_be_synced]: "பதிவு ஆஃப்லைனில் சேமிக்கப்பட்டுள்ளது, ஒத்திசைவு நிலுவையில் உள்ளது",
    [LangKeys.cash_in]: 'பணம் சேர்க்கப்பட்டது',
    [LangKeys.cash_out]: 'பணம் எடுத்தது',
    [LangKeys.cashbook_status]: 'கேஷ்புக் நிலை',
    [LangKeys.real_time_cash_online]: 'ரியல்-டைம் பணம் & ஆன்லைன்',

    // NEW Cashbook Specific keys
    [LangKeys.entry_is_backed_up]: "நுழைவு காப்புப் பிரதி எடுக்கப்பட்டது",
    [LangKeys.safe_and_secure]: "100% பாதுகாப்பானது மற்றும் பாதுகாப்பானது",
    [LangKeys.invalid_image_format_cashbook_popup]: "ஆதரிக்கப்படாத வடிவம். தயவுசெய்து JPG, PNG அல்லது WEBP ஐப் பயன்படுத்தவும்.",
    [LangKeys.photo_size_error_cashbook_popup]: "கோப்பு மிகப் பெரியது (அதிகபட்சம் 4MB)",
    [LangKeys.selected_image]: "தேர்ந்தெடுக்கப்பட்டது",

    // Cashbook Report Screen keys
    [LangKeys.cashbook_report_title]: "பணப் புத்தக அறிக்கை",
    [LangKeys.date_range]: "தேதி வரம்பு",
    [LangKeys.single_day]: "ஒற்றை நாள்",
    [LangKeys.this_week]: "இந்த வாரம்",
    [LangKeys.this_month]: "இந்த மாதம்",
    [LangKeys.last_week]: "கடந்த வாரம்",
    [LangKeys.last_month]: "கடந்த மாதம்",
    [LangKeys.all]: "அனைத்தும்",
    [LangKeys.to]: "க்கு",
    [LangKeys.no_entries_found_period]: "இந்த காலகட்டத்தில் பதிவுகள் எதுவும் இல்லை.",
    [LangKeys.daily_balance_short]: "தினசரி இருப்பு",
    [LangKeys.download_pdf]: "PDF பதிவிறக்கவும்",
    [LangKeys.pdf_download_not_implemented]: "PDF பதிவிறக்கம் இன்னும் செயல்படுத்தப்படவில்லை.",

    [LangKeys.daily_details]: "தினசரி விவரங்கள்",
    [LangKeys.no_entries_on_this_day]: "இந்த நாளில் பதிவுகள் இல்லை",
    [LangKeys.add_entries_help]: "அவற்றை இங்கே காண பதிவுகளைச் சேர்க்கவும்.",
    [LangKeys.add_entry_to]: "பதிவைச் சேர்",
    [LangKeys.add_entry]: "பதிவைச் சேர்",
    [LangKeys.could_not_load_report]: "அறிக்கையை ஏற்ற முடியவில்லை.",

    // NEW Entry Details Screen specific keys
    [LangKeys.delete_failed]: "நீக்குவதில் தோல்வி",
    [LangKeys.photo_max_4mb]: "புகைப்படம் (அதிகபட்சம் 4MB)",
    [LangKeys.entry_of_amount]: "தொகையின் பதிவு ",

    // PDF CASHBOOK REPORT
    [LangKeys.daily_summary]: "தினசரி சுருக்கம்",
    [LangKeys.total_in]: "மொத்தம் உள்ளே",
    [LangKeys.total_out]: "மொத்தம் வெளியே",
    [LangKeys.no_data_available]: "தகவல் இல்லை",

    // Months (for date formatting)
    [LangKeys.month_1]: "ஜன",
    [LangKeys.month_2]: "பிப்",
    [LangKeys.month_3]: "மார்ச்",
    [LangKeys.month_4]: "ஏப்ரல்",
    [LangKeys.month_5]: "மே",
    [LangKeys.month_6]: "ஜூன்",
    [LangKeys.month_7]: "ஜூலை",
    [LangKeys.month_8]: "ஆக",
    [LangKeys.month_9]: "செப்",
    [LangKeys.month_10]: "அக்",
    [LangKeys.month_11]: "நவ",
    [LangKeys.month_12]: "டிச",

    // NEW Customer Supplier Add
    [LangKeys.add_customer]: "வாடிக்கையாளரைச் சேர்",
    [LangKeys.customer_already_exists]: 'வாடிக்கையாளர் ஏற்கனவே உள்ளார்',
    [LangKeys.supplier_already_exists]: 'சப்ளையர் ஏற்கனவே உள்ளார்',

    // ✅ NEW CASHBOOK EMPTY STATE
    [LangKeys.cashbook_welcome]: "வணக்கம்! இன்றைய பதிவுகளைச் செய்வோம்",
    [LangKeys.add_first_entry_btn]: "உங்கள் முதல் பதிவைச் சேர்க்கவும்",

    // ✅ NEW KEY FOR EMPTY STATE TEXT
    [LangKeys.add_customers_collect_faster]: "வாடிக்கையாளர்களைச் சேர்த்து, கட்டணங்களை விரைவாகச் சேகரிக்கவும்",

    // ✅ NEW KEYS FOR PERMISSIONS
    [LangKeys.permission_denied_title]: "அனுமதி மறுக்கப்பட்டது",
    [LangKeys.permission_denied_content]: "புகைப்பட அணுகல் நிரந்தரமாக மறுக்கப்பட்டுள்ளது. தயவுசெய்து பயன்பாட்டு அமைப்புகளுக்கு சென்று அதை இயக்கவும்.",
    [LangKeys.permission_denied_settings_button]: "அமைப்புகளை திறக்கவும்",
    [LangKeys.permission_denied_cancel_button]: "ரத்து செய்",
    [LangKeys.permission_denied_generic_message]: "அனுமதி மறுக்கப்பட்டுள்ளது. புகைப்படத்தை தேர்வு செய்ய தயவுசெய்து புகைப்பட அணுகலை அனுமதிக்கவும்.",

    // ✅ Contact Picker
    [LangKeys.permission_required]: "அனுமதி தேவை",
    [LangKeys.contacts_permission_message]: "Contact தேர்வு செய்ய Contacts அனுமதி தேவை. தயவுசெய்து app settings-ல் அதை இயக்கவும்.",
    [LangKeys.failed_to_open_contacts_picker]: "Contacts picker திறக்க முடியவில்லை.",
    [LangKeys.permission_denied_to_read_contacts]: "Contacts படிக்க அனுமதி மறுக்கப்பட்டது.",

    // ================= ADD ITEM SCREEN =================
    [LangKeys.tax_exempted]: "வரி விலக்கு",
    [LangKeys.no_gst]: "GST இல்லை",
    [LangKeys.select_photo]: "புகைப்படம் தேர்வு செய்யவும்",
    [LangKeys.gallery]: "கேலரி",
    [LangKeys.camera]: "கேமரா",
    [LangKeys.please_enter_item_name]: "தயவுசெய்து பொருளின் பெயரை உள்ளிடவும்",
    [LangKeys.failed_to_upload_image]: "படத்தை பதிவேற்ற முடியவில்லை",
    [LangKeys.item_updated_successfully]: "பொருள் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    [LangKeys.item_saved_successfully]: "பொருள் வெற்றிகரமாக சேமிக்கப்பட்டது",
    [LangKeys.failed_to_update_item]: "பொருளை புதுப்பிக்க முடியவில்லை",
    [LangKeys.failed_to_save_item]: "பொருளை சேமிக்க முடியவில்லை",
    [LangKeys.confirm_deletion]: "நீக்கலை உறுதிப்படுத்தவும்",
    [LangKeys.are_you_sure_delete_item]: "இந்த பொருளை நீக்க விரும்புகிறீர்களா?",
    [LangKeys.item_deleted_successfully]: "பொருள் வெற்றிகரமாக நீக்கப்பட்டது",
    [LangKeys.failed_to_delete_item]: "பொருளை நீக்க முடியவில்லை",
    [LangKeys.edit_item]: "பொருளை திருத்தவும்",
    [LangKeys.edit_service]: "சேவையை திருத்தவும்",
    [LangKeys.add_product]: "பொருளை சேர்க்கவும்",
    [LangKeys.add_service]: "சேவையை சேர்க்கவும்",
    [LangKeys.add_hsn_and_gst_details]: "HSN மற்றும் GST விவரங்களை சேர்க்கவும்",
    [LangKeys.hsn]: "HSN",
    [LangKeys.enter_hsn]: "HSN உள்ளிடவும்",
    [LangKeys.gst_rate_percent]: "GST விகிதம் (%)",
    [LangKeys.enter_gst_rate]: "GST விகிதத்தை உள்ளிடவும்",
    [LangKeys.primary_unit]: "முதன்மை அலகு",
    [LangKeys.enter_item_name_here]: "இங்கே பொருளின் பெயரை எழுதவும்",
    [LangKeys.sale_price]: "விற்பனை விலை",
    [LangKeys.purchase_price]: "கொள்முதல் விலை",
    [LangKeys.tax_included]: "வரியுடன் சேர்க்கப்பட்டுள்ளது",
    [LangKeys.opening_stock]: "தொடக்க இருப்பு",
    [LangKeys.low_stock_alert]: "குறைந்த இருப்பு எச்சரிக்கை",
    [LangKeys.as_of_date]: "தேதி வரை",
    [LangKeys.enter_price]: "விலையை உள்ளிடவும்",
    [LangKeys.enter_count]: "அளவை உள்ளிடவும்",
    [LangKeys.save_item]: "பொருளை சேமிக்கவும்",
    [LangKeys.delete_item]: "பொருளை நீக்கவும்",
    [LangKeys.select_unit]: "அலகை தேர்வு செய்யவும்",
    [LangKeys.search_unit]: "அலகை தேடவும்",
    [LangKeys.add_gst_rate]: "GST விகிதத்தை சேர்க்கவும்",
    [LangKeys.add_custom_tax]: "தனிப்பயன் வரி சேர்க்கவும்",
    [LangKeys.custom_tax]: "தனிப்பயன் வரி",
    [LangKeys.gst]: "GST",
    [LangKeys.cess]: "செஸ்",
    [LangKeys.add_hsn_code]: "HSN குறியீடு சேர்க்கவும்",
    [LangKeys.hsn_code]: "HSN குறியீடு",
    [LangKeys.item_name]: "பொருளின் பெயர்",
    [LangKeys.enter_hsn_code]: "HSN குறியீட்டை உள்ளிடவும்",
    [LangKeys.enter_item_name]: "பொருளின் பெயரை உள்ளிடவும்",
    [LangKeys.results]: "முடிவுகள்",
    [LangKeys.no_hsn_code_found]: "HSN குறியீடு எதுவும் கிடைக்கவில்லை",
    [LangKeys.use]: "பயன்படுத்து",
    [LangKeys.as_hsn_code]: "HSN குறியீடாக",
    [LangKeys.you_are_offline_please_connect_to_the_internet]: "நீங்கள் ஆஃப்லைனில் உள்ளீர்கள். தயவுசெய்து இணையத்துடன் இணைக்கவும்.",

    // ================= ITEMS SCREEN =================
    [LangKeys.products]: "பொருட்கள்",
    [LangKeys.services]: "சேவைகள்",
    [LangKeys.add_product_caps]: "பொருள் சேர்க்கவும்",
    [LangKeys.add_service_caps]: "சேவை சேர்க்கவும்",
    [LangKeys.add_items_and_get_started]: "உங்கள் இன்வென்டரியை நிர்வகிக்க தொடங்குங்கள்",
    [LangKeys.manage_stock_feature]: "உங்கள் வியாபாரத்திற்கு ஸ்மார்ட் ஸ்டாக் கட்டுப்பாடு",
    [LangKeys.detailed_stock_history_feature]: "பொருள் செயல்பாடுகளின் முழுமையான பதிவுகளை அணுகுங்கள்",
    [LangKeys.track_prices_and_profits_feature]: "விலை மற்றும் லாப விகிதங்களை எளிதாக கண்காணிக்கவும்",
    [LangKeys.search_items]: "பொருட்களை தேடவும்",
    [LangKeys.my_items]: "என் பொருட்கள்",
    [LangKeys.item_added]: "பொருள் சேர்க்கப்பட்டது",
    [LangKeys.low_stock]: "குறைந்த இருப்பு",
    [LangKeys.current_stock]: "தற்போதைய இருப்பு",
    [LangKeys.stock_history]: "பங்கு வரலாறு",
    [LangKeys.stock_in]: "இருப்பு சேர்ப்பு",
    [LangKeys.stock_out]: "இருப்பு வெளியே",
    [LangKeys.add_services_and_get_started]: "உங்கள் சேவைகளை நிர்வகிக்க தொடங்குங்கள்",
    [LangKeys.manage_services_feature]: "உங்கள் அனைத்து சேவை வழங்கல்களையும் ஒழுங்குபடுத்து மற்றும் நிர்வகிக்கவும்",
    [LangKeys.save_sac_and_gst_feature]: "SAC குறியீடுகள் மற்றும் GST விவரங்களை எளிதாக சேமிக்கவும்",
    [LangKeys.track_sales_and_bills_feature]: "சேவை விற்பனை மற்றும் பில்லிங் பதிவுகளை கண்காணிக்கவும்",
    [LangKeys.net_monthly_sales]: "மொத்த மாத விற்பனை",
    [LangKeys.rupees]: "ரூபாய்",
    [LangKeys.search_services]: "சேவைகளை தேடவும்",
    [LangKeys.my_services]: "என் சேவைகள்",
    [LangKeys.service_price]: "சேவை விலை",
    [LangKeys.unit]: "அலகு",
    [LangKeys.enter_purchased_quantity]: "வாங்கிய அளவை உள்ளிடவும்",
    [LangKeys.enter_sold_quantity]: "விற்ற அளவை உள்ளிடவும்",
    [LangKeys.quantity]: "அளவு",
    [LangKeys.add_notes_optional]: "குறிப்பு சேர்க்கவும் (விருப்பம்)",
    [LangKeys.stock_in_caps]: "இருப்பு சேர்ப்பு",
    [LangKeys.stock_out_caps]: "இருப்பு வெளியே",
    [LangKeys.total_stock]: "மொத்த ஸ்டாக்",
    [LangKeys.low_stock_items]: "குறைந்த ஸ்டாக் உள்ள பொருட்கள்",
    [LangKeys.all_items]: "அனைத்து பொருட்கள்",
    [LangKeys.failed_to_load_items]: "பொருட்களை ஏற்ற முடியவில்லை",


    // ================= ITEMS SALES REPORT SCREEN =================

    [LangKeys.item_sales_report]: "பொருள் விற்பனை அறிக்கை",
    [LangKeys.total_qty_sold]: "மொத்தமாக விற்கப்பட்ட அளவு",
    [LangKeys.units]: "அலகுகள்",
    [LangKeys.nos]: "எண்ணிக்கை",
    [LangKeys.sold]: "விற்றது",
    [LangKeys.bought]: "வாங்கியது",
    [LangKeys.profit]: "லாபம்",
    [LangKeys.loss]: "இழப்பு",

    // Filter & Sort
    [LangKeys.filter_by_stock]: "பங்கு அடிப்படையில் வடிகட்டு",
    [LangKeys.sort_by_name_az]: "பெயர் (A–Z) வரிசை",
    [LangKeys.sort_by_name_za]: "பெயர் (Z–A) வரிசை",

    // ================= ADD SERVICE SCREEN =================
    [LangKeys.failed_to_process_image]: "படத்தை செயலாக்க முடியவில்லை",
    [LangKeys.could_not_pick_image]: "படத்தை தேர்வு செய்ய முடியவில்லை",
    [LangKeys.failed_to_upload_photo]: "புகைப்படத்தை பதிவேற்ற முடியவில்லை",
    [LangKeys.failed_to_update_service]: "சேவையை புதுப்பிக்க முடியவில்லை",
    [LangKeys.failed_to_add_service]: "சேவையை சேர்க்க முடியவில்லை",
    [LangKeys.are_you_sure_delete_service]: "இந்த சேவையை நீக்க விரும்புகிறீர்களா?",
    [LangKeys.failed_to_delete_service]: "சேவையை நீக்க முடியவில்லை",
    [LangKeys.add_sac_and_gst_details]: "SAC மற்றும் GST விவரங்களை சேர்க்கவும்",
    [LangKeys.sac_code]: "SAC குறியீடு",
    [LangKeys.enter_sac]: "SAC உள்ளிடவும்",
    [LangKeys.enter_service_name_here]: "இங்கே சேவையின் பெயரை எழுதவும்",
    [LangKeys.please_enter_service_name]: "தயவுசெய்து சேவையின் பெயரை உள்ளிடவும்",
    [LangKeys.tax_included_in_price]: "விலையில் வரி சேர்க்கப்பட்டுள்ளது",
    [LangKeys.delete_service]: "சேவையை நீக்கவும்",
    [LangKeys.save_changes]: "மாற்றங்களை சேமிக்கவும்",

    // ================= ITEM DETAILS SCREEN =================
    [LangKeys.edit_product]: "பொருளை திருத்தவும்",
    [LangKeys.stock_quantity]: "இருப்பு அளவு",
    [LangKeys.stock_value]: "இருப்பு மதிப்பு",

    // ================= SERVICE DETAILS SCREEN =================
    [LangKeys.edit_service_caps]: "சேவையை திருத்தவும்",
    [LangKeys.service_name]: "சேவையின் பெயர்",
    [LangKeys.gst_percent]: "GST %",
    [LangKeys.no_sales_added_for_service]: "இந்த சேவைக்கு எந்த விற்பனையும் சேர்க்கப்படவில்லை",
    [LangKeys.zero_percent]: "0%",

    [LangKeys.bills_add_sale]: "விற்பனை சேர்க்கவும்",
    [LangKeys.bills_search_sales_hint]: "விற்பனையை தேடுங்கள்",
    [LangKeys.bills_add_purchase]: "கொள்முதல் சேர்க்கவும்",
    [LangKeys.bills_search_purchases_hint]: "கொள்முதலை தேடுங்கள்",
    [LangKeys.bills_add_expense]: "செலவு சேர்க்கவும்",
    [LangKeys.bills_search_expenses_hint]: "செலவுகளை தேடுங்கள்",
    [LangKeys.bills_start_creating_gst]: "GST பில்களை உருவாக்க தொடங்குங்கள்",
    [LangKeys.bills_tab_sale]: "விற்பனை",
    [LangKeys.bills_tab_purchase]: "கொள்முதல்",
    [LangKeys.bills_tab_expense]: "செலவு",
    [LangKeys.bills_monthly_sales]: "மாதாந்திர விற்பனை",
    [LangKeys.bills_monthly_purchases]: "மாதாந்திர கொள்முதல்",
    [LangKeys.bills_view_reports]: "அறிக்கைகளை பார்க்கவும்",
    [LangKeys.bills_todays_in]: "இன்றைய வரவு",
    [LangKeys.bills_todays_out]: "இன்றைய செலவு",
    [LangKeys.bills_cashbook]: "கேஷ்புக்",
    [LangKeys.bills_empty_state_title]: "உடனடியாக தொழில்முறை இன்வாய்ஸ் உருவாக்குங்கள்",
    [LangKeys.bills_empty_state_subtitle]: "லெட்ஜர், ஸ்டாக் & கேஷ்புக் தானாக புதுப்பிக்கப்படும்",
    [LangKeys.bills_empty_state_gst_support]: "GST மற்றும் Non-GST பில்லிங் ஆதரவு",
    [LangKeys.bills_see_sample_invoices]: "மாதிரி இன்வாய்ஸ்களை பார்க்கவும்",
    [LangKeys.bills_no_matching_found]: "பொருந்தும் பில்கள் எதுவும் இல்லை",
    [LangKeys.bills_payment_in]: "பெறப்பட்ட பணம்",
    [LangKeys.bills_status_fully_paid]: "செலுத்தப்பட்டது",
    [LangKeys.bills_status_unpaid]: "பாக்கி",
    [LangKeys.bills_sale_bill]: "விற்பனை பில்",
    [LangKeys.bills_purchase_bill]: "கொள்முதல் பில்",
    [LangKeys.bills_expense_bill]: "செலவு",
    [LangKeys.bills_more_button]: "மேலும்",
    [LangKeys.bills_added_to_ledger]: "✓ கணக்கில்",

    // ================= FILTER & SORT =================
    [LangKeys.filter_and_sort]: "வடிகட்டி & வரிசைப்படுத்து",
    [LangKeys.filter_by_status]: "நிலைப்படி வடிகட்டு",
    [LangKeys.filter_all_bills]: "அனைத்து பில்ல்கள்",
    [LangKeys.filter_paid_bills]: "செலுத்தப்பட்ட பில்ல்கள்",
    [LangKeys.filter_unpaid_bills]: "செலுத்தப்படாத பில்ல்கள்",
    [LangKeys.sort_by]: "வரிசைப்படுத்து",
    [LangKeys.sort_latest_first]: "புதியவை முதலில்",
    [LangKeys.sort_oldest_first]: "பழையவை முதலில்",
    [LangKeys.sort_highest_amount]: "அதிக தொகை",
    [LangKeys.sort_lowest_amount]: "குறைந்த தொகை",
    [LangKeys.clear_filters]: "வடிகட்டலை நீக்கு",
    [LangKeys.apply_filters]: "வடிகட்டலை பயன்படுத்து",

    /* ================= ADD BILL SCREEN ================= */
    [LangKeys.add_bill_sale]: "விற்பனை",
    [LangKeys.add_bill_purchase]: "கொள்முதல்",
    [LangKeys.add_bill_expense]: "செலவு",

    [LangKeys.add_bill_edit_sale_gst_bill]: "விற்பனை GST திருத்து",
    [LangKeys.add_bill_sale_gst_bill]: "விற்பனை GST பில்",
    [LangKeys.add_bill_edit_purchase_gst_bill]: "கொள்முதல் GST திருத்து",
    [LangKeys.add_bill_purchase_gst_bill]: "கொள்முதல் GST பில்",

    [LangKeys.add_bill_edit_expense]: "செலவு திருத்து",
    [LangKeys.add_bill_expense_title]: "செலவு",

    [LangKeys.add_bill_edit_sale_bill]: "விற்பனை பில் திருத்து",
    [LangKeys.add_bill_sale_bill]: "விற்பனை பில்",
    [LangKeys.add_bill_edit_purchase_bill]: "கொள்முதல் பில் திருத்து",
    [LangKeys.add_bill_purchase_bill]: "கொள்முதல் பில்",

    [LangKeys.add_bill_sale_bill_no]: "விற்பனை பில் எண்",
    [LangKeys.add_bill_purchase_bill_no]: "கொள்முதல் பில் எண்",
    [LangKeys.add_bill_expense_no]: "செலவு எண்",

    [LangKeys.add_bill_update_sale_bill]: "விற்பனை பில் புதுப்",
    [LangKeys.add_bill_generate_sale_bill]: "விற்பனை பில் உருவாக்கு",
    [LangKeys.add_bill_update_purchase_bill]: "கொள்முதல் பில் புதுப்",
    [LangKeys.add_bill_generate_purchase_bill]: "கொள்முதல் பில் உருவாக்கு",
    [LangKeys.add_bill_update_expense]: "செலவு புதுப்",
    [LangKeys.add_bill_generate_expense]: "செலவு சேர்",

    [LangKeys.add_bill_select_customer_error]: "வாடிக்கையாளரை தேர்வு",
    [LangKeys.add_bill_add_item_error]: "குறைந்தது 1 பொருள்",

    [LangKeys.add_bill_updated_successfully]: "வெற்றிகரமாக புதுப்பிப்பு",
    [LangKeys.add_bill_saved_successfully]: "வெற்றிகரமாக சேமிப்பு",
    [LangKeys.add_bill_failed_to_save]: "சேமிக்க முடியவில்லை",
    [LangKeys.add_bill_error_occurred]: "பிழை ஏற்பட்டது",

    [LangKeys.add_bill_bill_to]: "பில் பெறுபவர்",
    [LangKeys.add_bill_search_parties]: "பார்டி தேடல்",
    [LangKeys.add_bill_add_new_party]: "புதிய பார்டி",
    [LangKeys.add_bill_edit_party_details]: "பார்டி விவரம்",

    [LangKeys.add_bill_items]: "பொருட்கள்",
    [LangKeys.add_bill_enter_items_from_inventory]: "ஸ்டாக்கில் இருந்து",
    [LangKeys.add_bill_add_new_item]: "புதிய பொருள்",
    [LangKeys.add_bill_n_items]: "{n} பொருட்கள்",
    [LangKeys.add_bill_edit_or_add_items]: "பொருள் சேர்/திருத்து",

    [LangKeys.add_bill_discount]: "தள்ளுபடி",
    [LangKeys.add_bill_extra_discount]: "கூடுதல் தள்ளுபடி",
    [LangKeys.add_bill_item_subtotal]: "உபமொத்தம்",
    [LangKeys.add_bill_round_off]: "ரவுண்ட் ஆஃப்",
    [LangKeys.add_bill_bill_amount]: "பில் தொகை",

    [LangKeys.add_bill_optional_fields]: "விருப்ப புலங்கள்",
    [LangKeys.add_bill_printed_on_invoice]: "இன்வாய்ஸில் அச்சு",
    [LangKeys.add_bill_custom_fields]: "கஸ்டம் புலங்கள்",

    [LangKeys.add_bill_party_address]: "பார்டி முகவரி",
    [LangKeys.add_bill_your_address]: "உங்கள் முகவரி",
    [LangKeys.add_bill_terms_conditions]: "விதிமுறைகள்",
    [LangKeys.add_bill_private_to_you]: "உங்களுக்கு மட்டும்",

    [LangKeys.add_bill_add_notes_photos]: "நோட்/புகைப்படம்",
    [LangKeys.add_bill_n_photos_added]: "{n} புகைப்படம்",
    [LangKeys.add_bill_balance_due]: "பாக்கி தொகை",

    [LangKeys.cgst]: "CGST",
    [LangKeys.sgst]: "SGST",
    [LangKeys.pending_bill_no]: "நிலுவை பில் எண்.",
    [LangKeys.add_bill_add_due_to_ledger]: "லெட்ஜரில் நிலுவை இருப்பை சேர்க்கவும்",
    [LangKeys.add_bill_select_supplier_error]: "தயவுசெய்து சப்ளையரை தேர்ந்தெடுக்கவும்",

    /* ================= BILL DETAILS SCREEN ================= */
    [LangKeys.bill_details_error_id_missing]: "பில் ID கிடைக்கவில்லை",
    [LangKeys.bill_details_failed_to_load]: "பிலை ஏற்ற முடியவில்லை",
    [LangKeys.bill_details_delete_confirmation_title]: "பிலை நீக்கு",
    [LangKeys.bill_details_delete_confirmation_content]: "இந்த பில்லைக் நீக்க விரும்புகிறீர்களா? இந்த பில்லுடன் தொடர்புடைய கேஷ்புக் பதிவு கூட நீக்கப்படும் என்பதை நினைவில் கொள்ளுங்கள்.",
    [LangKeys.bill_details_delete_button]: "நீக்கு",
    [LangKeys.bill_details_deleted_successfully]: "பில் வெற்றிகரமாக நீக்கப்பட்டது",
    [LangKeys.bill_details_failed_to_delete]: "பிலை நீக்க முடியவில்லை",
    [LangKeys.bill_details_generating_pdf]: "PDF உருவாக்கப்படுகிறது",
    [LangKeys.bill_details_share_text]: "இது உங்கள் பில்",
    [LangKeys.bill_details_failed_to_share]: "பிலை பகிர முடியவில்லை",
    [LangKeys.bill_details_title]: "பில் விவரங்கள்",
    [LangKeys.bill_details_could_not_load]: "பில் விவரங்களை ஏற்ற முடியவில்லை",
    [LangKeys.bill_details_status]: "நிலை",
    [LangKeys.bill_details_status_pending]: "நிலுவையில்",
    [LangKeys.bill_details_no_items]: "பொருட்கள் சேர்க்கப்படவில்லை",
    [LangKeys.bill_details_view_pdf]: "PDF பார்க்கவும்",

    /* ================= EXPENSE DETAILS SCREEN ================= */
    [LangKeys.expense_number_prefix]: "செலவு #",
    [LangKeys.edit_expense]: "செலவை திருத்து",
    [LangKeys.delete_expense]: "செலவை நீக்கு",
    [LangKeys.deleting_expense]: "நீக்கப்படுகிறது...",
    [LangKeys.expense_deleted_successfully]: "செலவு வெற்றிகரமாக நீக்கப்பட்டது",
    [LangKeys.failed_to_delete_expense]: "செலவை நீக்க முடியவில்லை",
    [LangKeys.edit_feature_coming_soon]: "திருத்தும் வசதி விரைவில் வருகிறது!",
    [LangKeys.delete_expense_confirmation]: "இந்த செலவை நீக்க விரும்புகிறீர்களா?",

    /* ================= INVOICE PREVIEW SCREEN ================= */
    [LangKeys.invoice_preview_title]: "இன்வாய்ஸ்",
    [LangKeys.invoice_preview_generating]: "உருவாகிறது",
    [LangKeys.invoice_preview_failed]: "தோல்வி",
    [LangKeys.invoice_preview_preparing_print]: "அச்சு தயார்",
    [LangKeys.invoice_preview_failed_print]: "அச்சு தோல்வி",
    [LangKeys.invoice_preview_delete_title]: "நீக்கு",
    [LangKeys.invoice_preview_delete_content]: "இந்த இன்வாய்ஸை நீக்க விரும்புகிறீர்களா? இதனுடன் தொடர்புடைய கேஷ்புக் பதிவு கூட நீக்கப்படும் என்பதை கவனத்தில் கொள்ளவும்.",
    [LangKeys.invoice_preview_deleted_successfully]: "நீக்கப்பட்டது",
    [LangKeys.invoice_preview_failed_delete]: "நீக்கல் தோல்வி",
    [LangKeys.invoice_preview_theme_premium]: "ப்ரீ",
    [LangKeys.invoice_preview_theme_thermal]: "தெர்மல்",
    [LangKeys.invoice_preview_theme_basic]: "பேசிக்",
    [LangKeys.invoice_preview_theme_new]: "புதிய",
    [LangKeys.invoice_preview_download]: "டவுன்லோடு",
    [LangKeys.invoice_preview_share]: "ஷேர்",
    [LangKeys.invoice_preview_print]: "அச்சு",
    [LangKeys.invoice_preview_create_new]: "புதிய",
    [LangKeys.invoice_preview_done]: "முடிந்தது",

    /* ================= PAYMENT DETAILS SCREEN ================= */
    [LangKeys.payment_details_title_in]: "பெறப்பட்ட பணம்",
    [LangKeys.payment_details_title_out]: "செலுத்திய பணம்",
    [LangKeys.payment_details_share_text]: "பணம் செலுத்திய விவரங்கள்",
    [LangKeys.payment_details_failed_to_share]: "பணம் விவரங்களை பகிர முடியவில்லை",
    [LangKeys.payment_details_adjusted_invoices]: "சரிசெய்யப்பட்ட இன்வாய்ஸ்கள்",

    /* ================= SAMPLE INVOICES SCREEN ================= */
    [LangKeys.sample_invoice_title]: "மாதிரி",
    [LangKeys.premium_invoice]: "ப்ரீமியம் இன்வாய்ஸ்",
    [LangKeys.thermal_invoice]: "தெர்மல் இன்வாய்ஸ்",
    [LangKeys.basic_invoice]: "பேசிக் இன்வாய்ஸ்",
    [LangKeys.use_this_template]: "இந்த டெம்ப்ளேட்டை பயன்படுத்தவும்",

    /* ================= ITEM SELECT SHEET ================= */
    [LangKeys.item_select_not_enough_stock]: "ஸ்டாக் இல்லை ({availableStock})",
    [LangKeys.item_select_no_items_found]: "பொருட்கள் இல்லை",
    [LangKeys.item_select_item_discount]: "தள்ளுபடி",
    [LangKeys.item_select_final_price]: "இறுதி விலை",
    [LangKeys.item_select_gst_rate]: "GST %",
    [LangKeys.item_select_item_single]: "பொருள்",
    [LangKeys.item_select_item_plural]: "பொருட்கள்",
    [LangKeys.item_select_continue]: "தொடர்",
    [LangKeys.item_select_add_items_to_invoice]: "இன்வாய்ஸில் சேர்க்க",
    [LangKeys.item_select_search_created_items]: "பொருள் தேடல்",
    [LangKeys.item_select_add_new]: "புது",

    /* ================= QUICK ADD ITEM DIALOG ================= */
    [LangKeys.add_more_details]: "மேலும் விவரங்களை சேர்க்கவும் (ஸ்டாக், கொள்முதல் விலை போன்றவை)",
    [LangKeys.add_item_to_bill]: "பிலில் சேர்",
    [LangKeys.please_enter_value]: "தயவு செய்து ஒரு மதிப்பை உள்ளிடவும்",
    [LangKeys.please_enter_valid_number]: "தயவு செய்து சரியான எண்ணை உள்ளிடவும்",

    /* ================= CUSTOM FIELDS DIALOG ================= */
    [LangKeys.add_bill_custom_fields_subtitle]: "அதிகபட்சம் 5 தனிப்பயன் புலங்களை சேர்க்கலாம் (உதா: சீரியல் எண், பேட்ச், IMEI போன்றவை)",
    [LangKeys.add_bill_add_new_custom_field]: "புதிய தனிப்பயன் புலத்தை சேர்க்கவும்",
    [LangKeys.add_bill_max_custom_fields]: "அதிகபட்சம் 5 தனிப்பயன் புலங்களை மட்டுமே சேர்க்கலாம்.",
    [LangKeys.add_bill_custom_field_name_hint]: "புலத்தின் பெயர்",
    [LangKeys.add_bill_custom_field_value_hint]: "மதிப்பு",

    /* ================= EDIT PRICE DIALOG ================= */
    [LangKeys.edit_price_gst_details]: "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
    [LangKeys.edit_price_enter_discount_hint]: "தள்ளுபடியை உள்ளிடவும்",
    [LangKeys.rupee]: "ரூபாய்",
    [LangKeys.percentage]: "சதவீதம்",
    [LangKeys.rate]: "விகிதம்",
    [LangKeys.tax]: "வரி",

    [LangKeys.address_business_address_title]: "வணிக முகவரி",
    [LangKeys.address_flat_building_number]: "பிளாட் / கட்டிடம் எண்",
    [LangKeys.address_enter_flat_building_number]: "பிளாட் / கட்டிடம் எண்ணை உள்ளிடவும்",
    [LangKeys.address_area_locality]: "பகுதி / உள்ளூர் பகுதி",
    [LangKeys.address_enter_area_locality]: "பகுதி / உள்ளூர் பகுதியை உள்ளிடவும்",
    [LangKeys.address_city]: "நகரம்",
    [LangKeys.address_enter_city]: "நகரத்தை உள்ளிடவும்",
    [LangKeys.address_state]: "மாநிலம்",
    [LangKeys.address_enter_state]: "மாநிலத்தை உள்ளிடவும்",
    [LangKeys.address_pincode]: "பின்கோடு",
    [LangKeys.address_enter_pincode]: "பின்கோட்டை உள்ளிடவும்",
    [LangKeys.address_invalid_pincode]: "தவறான பின்கோடு",

    /* ================= PARTY ADDRESS SCREEN ================= */
    [LangKeys.party_address_title]: "வாடிக்கையாளர் முகவரி",
    [LangKeys.party_address_billing_address]: "பில்லிங் முகவரி",
    [LangKeys.party_address_shipping_same_as_billing]: "ஷிப்பிங் முகவரி பில்லிங் முகவரியுடன் ஒன்றாக உள்ளது",

    /* ================= ADD NOTES AND PHOTOS DIALOG ================= */
    [LangKeys.add_notes_and_photos_title]: "நோட் & புகைப்படம்",
    [LangKeys.add_notes_and_photos_subtitle]: "கூடுதல் விவரங்கள் அல்லது படங்களை சேர்க்கவும்",
    [LangKeys.add_notes_and_photos_notes_hint]: "இங்கே குறிப்புகளை எழுதுங்கள்",
    [LangKeys.photos_access_permanently_denied]: "புகைப்பட அணுகல் நிரந்தரமாக மறுக்கப்பட்டுள்ளது. அனுமதியை வழங்க ஆப் அமைப்புகளுக்கு செல்லவும்.",
    [LangKeys.photos_access_denied]: "புகைப்படத்தை தேர்வு செய்ய, உங்கள் சாதன அமைப்புகளில் கேமரா அல்லது புகைப்பட அணுகலுக்கு அனுமதி வழங்கவும்.",
    [LangKeys.open_settings]: "அமைப்புகளை திறக்கவும்",

    /* ================= TERMS AND CONDITIONS DIALOG ================= */
    [LangKeys.terms_and_conditions_title]: "விதிமுறைகள் & நிபந்தனைகள்",
    [LangKeys.terms_and_conditions_hint]: "விதிமுறைகள் மற்றும் நிபந்தனைகளை உள்ளிடவும்",

    // ================= KHATA TABS =================
    [LangKeys.customers]: "வாடிக்கையாளர்கள்",
    [LangKeys.suppliers]: "சப்ளையர்கள்",
    [LangKeys.search_supplier]: "சப்ளையரை தேடுங்கள்",
    [LangKeys.add_first_customer]: "உங்கள் முதல் வாடிக்கையாளரை சேர்க்கவும்",
    [LangKeys.add_first_supplier]: "உங்கள் முதல் சப்ளையரை சேர்க்கவும்",
    [LangKeys.add_new_customer_prompt]: "இன்னும் எந்த வாடிக்கையாளரும் சேர்க்கப்படவில்லை. புதிய வாடிக்கையாளரை சேர்க்க மேலே உள்ள “+” பொத்தானை தட்டவும்.",
    [LangKeys.add_new_suppliers_prompt]: "இன்னும் எந்த சப்ளையரும் சேர்க்கப்படவில்லை. புதிய சப்ளையரை சேர்க்க மேலே உள்ள “+” பொத்தானை தட்டவும்.",

    // ================= CASHBOOK HELP DIALOG =================
    [LangKeys.cashbook_help_title]: "கேஷ்புக் உதவி",
    [LangKeys.cashbook_help_in_title]: "கேஷ் இன் (வைப்பு)",
    [LangKeys.cashbook_help_in_desc]: "இங்கே உங்கள் வியாபாரத்தில் பெறப்பட்ட அனைத்து ரொக்க பதிவுகளின் விவரங்கள் காட்டப்படும்.",
    [LangKeys.cashbook_help_out_title]: "கேஷ் அவுட் (பறிப்பு)",
    [LangKeys.cashbook_help_out_desc]: "இங்கே உங்கள் வியாபாரத்தில் செலவிடப்பட்ட அனைத்து ரொக்க பதிவுகளின் விவரங்கள் காட்டப்படும்.",
    [LangKeys.cashbook_help_total_balance_title]: "மொத்த இருப்பு",
    [LangKeys.cashbook_help_total_balance_desc]: "இது உங்கள் கேஷ்புக்கின் தற்போதைய மொத்த இருப்பை காட்டுகிறது.",
    [LangKeys.cashbook_help_today_balance_title]: "இன்றைய இருப்பு",
    [LangKeys.cashbook_help_today_balance_desc]: "இது இன்றைய ரொக்க பரிவர்த்தனைகளை மட்டும் அடிப்படையாகக் கொண்டு இருப்பை காட்டுகிறது.",
    [LangKeys.cashbook_help_report_title]: "கேஷ்புக் அறிக்கை",
    [LangKeys.cashbook_help_report_desc]: "இங்கே இருந்து கேஷ்புக் அறிக்கையை பார்க்கவும் பதிவிறக்கம் செய்யவும் முடியும்.",

    // ✅ NEW KEYS FOR ADD EXPENSE SCREEN
    [LangKeys.expense_amount]: "செலவு தொகை",
    [LangKeys.select_category]: "வகையை தேர்வு செய்யவும்",
    [LangKeys.select_expense_category]: "செலவு வகையை தேர்வு செய்யவும்",
    [LangKeys.expense_items_warning]: "செலவு பொருட்கள் உங்கள் இருப்புப் பொருட்களை பாதிக்காது.",
    [LangKeys.add_expense_items_optional]: "செலவு பொருட்களை சேர்க்கவும் (விருப்பத்தேர்வு)",
    [LangKeys.expense_items_feature_coming_soon]: "செலவு பொருட்கள் வசதி விரைவில் வருகிறது!",
    [LangKeys.notes_and_photos_optional]: "குறிப்புகள் மற்றும் புகைப்படங்கள் (விருப்பத்தேர்வு)",
    [LangKeys.photos_added]: "புகைப்படங்கள் சேர்க்கப்பட்டன",
    [LangKeys.save_expense_amount]: "செலவை சேமிக்கவும்",
    [LangKeys.update_expense_amount]: "செலவை புதுப்பிக்கவும்",
    [LangKeys.expense_saved_successfully]: "செலவு வெற்றிகரமாக சேமிக்கப்பட்டது",
    [LangKeys.expense_updated_successfully]: "செலவு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    [LangKeys.failed_to_save_expense]: "செலவை சேமிக்க முடியவில்லை",
    [LangKeys.enter_valid_amount]: "தயவுசெய்து சரியான தொகையை உள்ளிடவும்.",
    [LangKeys.please_select_expense_category]: "தயவுசெய்து செலவு வகையை தேர்வு செய்யவும்.",
    [LangKeys.category]: "வகை",

    // ===== EXPENSE CATEGORIES =====
    [LangKeys.cat_rent]: "வாடகை",
    [LangKeys.cat_salaries]: "சம்பளம் / கூலி",
    [LangKeys.cat_electricity]: "மின்சாரம்",
    [LangKeys.cat_water]: "தண்ணீர் கட்டணம்",
    [LangKeys.cat_internet]: "தொலைபேசி / இணையம்",
    [LangKeys.cat_office]: "அலுவலக செலவுகள்",
    [LangKeys.cat_marketing]: "மார்க்கெட்டிங் / விளம்பரம்",
    [LangKeys.cat_travel]: "பயணம்",
    [LangKeys.cat_fuel]: "எரிபொருள் / பெட்ரோல்",
    [LangKeys.cat_food]: "உணவு / சிற்றுண்டி",
    [LangKeys.cat_repairs]: "பழுது பார்த்தல் மற்றும் பராமரிப்பு",
    [LangKeys.cat_election]: "தேர்தல் செலவுகள்",
    [LangKeys.cat_taxes]: "வரி / GST",
    [LangKeys.cat_insurance]: "காப்பீடு",
    [LangKeys.cat_cleaning]: "சுத்தம்",
    [LangKeys.cat_delivery]: "டெலிவரி / ஷிப்பிங்",
    [LangKeys.cat_software]: "மென்பொருள் / செயலிகள்",
    [LangKeys.cat_furniture]: "மரச்சாமான்கள்",
    [LangKeys.cat_other]: "மற்றவை",

    // ================= EXPENSE EMPTY STATE =================
    [LangKeys.expense_empty_title]: "உங்கள் செலவுகளை எளிதாக நிர்வகிக்கவும்",
    [LangKeys.expense_empty_subtitle]: "உங்கள் வணிகத்தின் அனைத்து செலவுகளையும் ஒரே இடத்தில் கண்காணிக்கவும்.",
    [LangKeys.expense_empty_footer]: "அனைத்து செலவுகளும் தானாகவே கேஷ்புக்கில் சேர்க்கப்படும்.",

    // ================= BILL REPORT SCREEN =================
    [LangKeys.bill_report_title]: "பில் அறிக்கை",
    [LangKeys.report_for_period]: "இந்த காலத்திற்கு அறிக்கை",
    [LangKeys.select_date_range]: "தேதி வரம்பை தேர்வு செய்யவும்",
    [LangKeys.total_sales]: "மொத்த விற்பனை",
    [LangKeys.total_purchases]: "மொத்த கொள்முதல்",
    [LangKeys.total_expenses]: "மொத்த செலவுகள்",
    [LangKeys.net_profit]: "நிகர லாபம்",
    [LangKeys.net_loss]: "நிகர இழப்பு",
    [LangKeys.all_transactions]: "அனைத்து பரிவர்த்தனைகள்",
    [LangKeys.no_transactions_found_period]: "இந்த காலத்தில் எந்த பரிவர்த்தனையும் கிடைக்கவில்லை",
    [LangKeys.expense_fallback_category]: "மற்ற செலவுகள்",

    // ================= SALES REPORT SCREEN =================
    [LangKeys.sales_report]: "விற்பனை அறிக்கை",
    [LangKeys.transactions]: "பரிவர்த்தனைகள்",
    [LangKeys.net_sale]: "நிகர விற்பனை",
    [LangKeys.unpaid_balance]: "பாக்கி தொகை",
    [LangKeys.sales_report_share_text]: "இது உங்கள் விற்பனை அறிக்கையின் சுருக்கம்.",

    // ================= PURCHASE REPORT SCREEN =================
    [LangKeys.purchase_report]: "கொள்முதல் அறிக்கை",
    [LangKeys.net_purchase]: "நிகர கொள்முதல்",
    [LangKeys.purchase_report_share_text]: "இது உங்கள் கொள்முதல் அறிக்கையின் சுருக்கம்.",

    // ================= KHATA FILTER & SORT =================
    [LangKeys.filter_by_balance]: "இருப்பு தொகையின் அடிப்படையில் வடிகட்டு",
    [LangKeys.filter_all_parties]: "அனைத்து தரப்புகள்",

    // ================= LOGOUT =================
    [LangKeys.logout_confirm]: "நீங்கள் உண்மையில் வெளியேற விரும்புகிறீர்களா?",
    [LangKeys.confirm_logout]: "வெளியேறு",

    // ================= DEVICES =================
    [LangKeys.manage_devices]: "சாதனங்களை நிர்வகிக்கவும்",
    [LangKeys.active_devices]: "செயலில் உள்ள சாதனங்கள்",
    [LangKeys.logout_device]: "சாதனத்தை வெளியேறு",
    [LangKeys.logout_device_confirm]: "இந்த சாதனத்தை வெளியேற்ற விரும்புகிறீர்களா?",
    [LangKeys.device_logged_out]: "சாதனம் வெற்றிகரமாக வெளியேற்றப்பட்டது",
    [LangKeys.no_active_devices]: "செயலில் உள்ள சாதனங்கள் இல்லை",
    [LangKeys.last_login]: "கடைசி உள்நுழைவு",
    [LangKeys.this_device]: "இந்த சாதனம்",
    [LangKeys.loading_devices]: "சாதனங்கள் ஏற்றப்படுகின்றன...",

    /* ================= SMS SETTINGS ================= */
    [LangKeys.send_whatsapp_messages]: "வாட்ஸ்அப் செய்திகளை அனுப்புதல்",
    [LangKeys.enabled]: "இயக்கம்",
    [LangKeys.disabled]: "முடக்கம்",
    [LangKeys.manage_whatsapp_settings]: "வாட்ஸ்அப் SMS அமைப்புகளை நிர்வகிக்கவும்",
    [LangKeys.recharge_and_control]: "கிரெடிட்களை ரீசார்ஜ் செய்து செய்திகளை கட்டுப்படுத்தவும்",

    [LangKeys.wa_message_failed]: "செய்தி அனுப்பதில் தோல்வி",
    [LangKeys.wa_no_credits]: "கிரெடிட் முடிந்தது, செய்தி அனுப்பப்படவில்லை",


    // DASHBOARD EMPTY STATE
    [LangKeys.pro_tip]: "ப்ரோ டிப்",
    [LangKeys.dashboard_empty_tip]: "முழு விவரங்களை பார்க்க, திருத்த அல்லது வாடிக்கையாளர்களுடன் பகிர இடதுபுறத்தில் உள்ள எந்த பதிவையும் கிளிக் செய்யவும்.",
    [LangKeys.select_entry]: "பதிவை தேர்வு செய்யவும்",
    [LangKeys.entry_details_appear]: "பதிவு விவரங்கள் இங்கே தோன்றும்",



    // REPORTS DASHBOARD
    [LangKeys.business_reports]: "வணிக அறிக்கைகள்",
    [LangKeys.business_reports_desc]: "உங்கள் வணிகத்திற்கான பகுப்பாய்வு மற்றும் நுண்ணறிவுகள்",
    [LangKeys.ledger_cashbook_reports]: "லெட்ஜர் & காசுப்புத்தக அறிக்கைகள்",
    [LangKeys.billing_inventory_reports]: "பில்லிங் & சரக்கு அறிக்கைகள்",
    [LangKeys.customer_ledger_statement_report]: "வாடிக்கையாளர் லெட்ஜர் அறிக்கை",
    [LangKeys.customer_ledger_report_desc]: "வாடிக்கையாளர்களின் விரிவான பரிவர்த்தனை வரலாறு மற்றும் இருப்பு அறிக்கை",
    [LangKeys.supplier_ledger_statement_report]: "சப்ளையர் லெட்ஜர் அறிக்கை",
    [LangKeys.supplier_ledger_report_desc]: "சப்ளையர்களின் விரிவான பரிவர்த்தனை வரலாறு மற்றும் இருப்பு அறிக்கை",
    [LangKeys.cashbook_report_desc]: "பணம் மற்றும் ஆன்லைன் பரிவர்த்தனைகளின் தினசரி சுருக்க அறிக்கை",
    [LangKeys.sales_report_desc]: "பில் வாரியான விற்பனை சுருக்கம், மொத்த விற்பனை மற்றும் நிலுவைத் தொகை விவரங்கள்",
    [LangKeys.purchase_report_desc]: "பில் வாரியான கொள்முதல் பதிவுகள் மற்றும் சுருக்கங்கள்",
    [LangKeys.bills_summary_report]: "பில்கள் சுருக்க அறிக்கை",
    [LangKeys.bills_summary_report_desc]: "விற்பனை, கொள்முதல் மற்றும் லாபம்/நஷ்டத்தின் முழுமையான பகுப்பாய்வு",
    [LangKeys.item_stock_sales_report]: "பொருள் இருப்பு & விற்பனை அறிக்கை",
    [LangKeys.item_stock_sales_report_desc]: "தயாரிப்புகள் மற்றும் சேவைகளின் இருப்பு நிலை மற்றும் விற்பனை சுருக்கம்",
    [LangKeys.select_party]: "பார்ட்டியைத் தேர்ந்தெடுக்கவும்",
    [LangKeys.search_placeholder]: "பெயர் அல்லது மொபைல் எண்ணால் தேடவும்...",
    [LangKeys.back_to_dashboard]: "அறிக்கைகள் மெனுவிற்கு செல்லவும்",
    [LangKeys.loading_report_data]: "அறிக்கை ஏற்றப்படுகிறது...",
    [LangKeys.no_parties_found]: "எந்த பார்ட்டியும் கிடைக்கவில்லை.",
    [LangKeys.select_customer]: "அறிக்கையைப் பார்க்க வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்",
    [LangKeys.select_supplier]: "அறிக்கையைப் பார்க்க சப்ளையரைத் தேர்ந்தெடுக்கவும்",
    [LangKeys.premium_feature]: "பிரீமியம் அம்சம்",
    [LangKeys.premium_lock_desc]: "தொழில்முறை பில்லிங், விற்பனை/கொள்முதல் இன்வாய்ஸ் அறிக்கைகள், தினசரி கணக்கு அறிக்கைகள் மற்றும் சரக்கு சுருக்கங்களைத் திறக்கவும்.",
    [LangKeys.upgrade_to_premium]: "Ads Free+ / Premium-க்கு மேம்படுத்தவும் 🚀",
  // PREMIUM
  [LangKeys.plan_standard_name]: "ஸ்டாண்டர்ட் (விளம்பரமில்லா)",
  [LangKeys.plan_ads_free_name]: "விளம்பரமில்லா +",
  [LangKeys.plan_premium_name]: "பிரீமியம்",
  [LangKeys.plan_recommended_tag]: "பரிந்துரைக்கப்பட்ட திட்டம்",
  [LangKeys.plan_duration_30_days]: "30 நாட்களுக்கு",
  [LangKeys.plan_duration_180_days]: "180 நாட்களுக்கு (6 மாதங்கள்)",
  [LangKeys.plan_duration_365_days]: "365 நாட்களுக்கு (1 வருடம்)",
  [LangKeys.plan_duration_30_days_badge]: "30 நாட்கள்",
  [LangKeys.plan_save_20_percent]: "சேமிப்பு ~20%",
  [LangKeys.plan_best_value_badge]: "சிறந்த மதிப்பு",
  [LangKeys.plan_best_value_plan_tag]: "சிறந்த மதிப்பு திட்டம்",
  [LangKeys.plan_most_popular_save]: "மிகவும் பிரபலமானது • ₹{amount} சேமிப்பு",
  [LangKeys.plan_save_amount_tag]: "₹{amount} சேமிப்பு",
  [LangKeys.duration_1_month]: "1 மாதம்",
  [LangKeys.duration_6_months]: "6 மாதங்கள்",
  [LangKeys.duration_12_months]: "12 மாதங்கள்",
  [LangKeys.plan_save_text]: "சேமி",
  [LangKeys.benefit_no_ads]: "விளம்பரங்கள் இல்லை (100% விளம்பரமற்ற அனுபவம்)",
  [LangKeys.benefit_support]: "24/7 முன்னுரிமை வாடிக்கையாளர் ஆதரவு",
  [LangKeys.benefit_all_ads_free]: "Ads Free + திட்டத்தின் அனைத்து நன்மைகளும்",
  [LangKeys.benefit_multiple_devices]: "ஒரே நேரத்தில் பல சாதனங்களில் உள்நுழையலாம்",
  [LangKeys.benefit_desktop_access]: "கணினி/டெஸ்க்டாப் அணுகல்",
  [LangKeys.benefit_create_bills]: "பில்லுகள் உருவாக்கவும் (சாதாரண பில், GST பில்)",
  [LangKeys.benefit_defaulters_list]: "ஒரு கிளிக்கில் பாக்கியாளர்கள் பட்டியல் பார்க்கவும்",
  [LangKeys.benefit_organize_lists]: "பட்டியல்களுடன் உங்கள் கணக்குகளை ஒழுங்குபடுத்துங்கள்",
  [LangKeys.benefit_manage_stocks]: "ஸ்டாக்குகளை நிர்வகிக்கவும் (பரிவர்த்தனைகளுடன் பொருட்களை சேர்க்கவும்)",
  [LangKeys.benefit_financial_reports]: "பிரீமியம் நிதி அறிக்கைகள் (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "பாதுகாப்பான லோகல் மற்றும் கிளவுட் சேமிப்பில் இரட்டை காப்புப்பிரதி",
  [LangKeys.benefit_unlimited_entry]: "கேஷ்புக்/கணக்கில் வரம்பற்ற உள்ளீடுகள்",
  [LangKeys.benefit_unlimited_transactions]: "வரம்பற்ற பரிவர்த்தனைகள் (Unlimited Transactions)",
  [LangKeys.benefit_unlimited_sms]: "வரம்பற்ற SMS",
  [LangKeys.benefit_dairy_management]: "பால் பண்ணை வசதிகள் (பால் பதிவுகள், விலை அட்டவணைகள், பில்கள்)",
  [LangKeys.benefit_refer_earn]: "பரிந்துரைத்து சம்பாதிக்க (இலவச ரீசார்ஜ் செல்லுபடியாகும் காலம்)",
  [LangKeys.my_subscription_title]: "என் சந்தா",
  [LangKeys.premium_plans_title]: "எங்கள் பிரீமியம் திட்டங்கள்",
  [LangKeys.active_badge_label]: "செயலில்",
  [LangKeys.expires_on_label]: "காலாவதியாகும் தேதி {date}",
  [LangKeys.expired_badge_label]: "காலாவதியானது",
  [LangKeys.expired_on_label]: "{date} அன்று காலாவதியானது",
  [LangKeys.extend_plan_label]: "திட்டத்தை நீட்டிக்கவும் (+{days} நாட்கள்)",
  [LangKeys.days_remaining_label]: "({days} நாட்கள் மீதமுள்ளது)",
  [LangKeys.secure_checkout_label]: "100% பாதுகாப்பான SSL கட்டணம்",
  [LangKeys.upgrade_button]: "மேம்படுத்தவும்",
  [LangKeys.downgrade_button]: "தரமிறக்கவும்",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'ஆன்லைன் ஸ்டோர் அமைப்புகள் (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'ஆன்லைன் வணிகத்தை இயக்கத்தில் வைக்கவும்',
  [LangKeys.biz_profile__online_business_active]: 'வணிகம் ஆன்லைனில் செயலில் உள்ளது (Active)',
  [LangKeys.biz_profile__online_business_offline]: 'வணிகம் ஆன்லைனில் மூடப்பட்டுள்ளது (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'ஆன்லைனில் செயலில் உள்ளது (GPS அமைக்கவும்)',
  [LangKeys.biz_profile__online_business_sub_active]: 'இயக்கிய பிறகு 1-கிளிக்கில் மாநிலம், மாவட்டம், பகுதி மற்றும் பின்கோடை நிரப்பி GPS அமைக்கவும், இதனால் உங்கள் கடை வாடிக்கையாளர்களுக்குத் தெரியும்.',
  [LangKeys.biz_profile__online_business_sub_offline]: 'உள்ளூர் சந்தையில் அருகிலுள்ள வாடிக்கையாளர்கள் உங்கள் தயாரிப்புகளையும் சேவைகளையும் கண்டறிய ஆன்லைன் வணிகத்தை இயக்கவும்.',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 இதன் நன்மைகள் மற்றும் விதிகளை அறியவும்',
  [LangKeys.biz_profile__benefits_modal_title]: 'ஆன்லைன் வணிகத்தின் நன்மைகள் மற்றும் முழு தகவல்',
  [LangKeys.biz_profile__benefits_step1_title]: '1. இதை இயக்குவதால் என்ன நடக்கும்?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'உங்கள் வணிகம், தயாரிப்புகள் மற்றும் சேவைகள் உடனடியாக உள்ளூர் சந்தையில் நேரலையாகும். அருகிலுள்ள வாடிக்கையாளர்கள் உங்களை அணுகலாம்.',
  [LangKeys.biz_profile__benefits_step2_title]: '2. நீங்கள் என்ன செய்ய வேண்டும்?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• நீல நிற பொத்தானைப் (⚡ 1-கிளிக்) பயன்படுத்தி முகவரி மற்றும் GPS-ஐ தானாக நிரப்பவும்.\n• உங்கள் தயாரிப்புகள் அல்லது சேவைகளைச் சேர்க்கவும்.',
  [LangKeys.biz_profile__benefits_step3_title]: '3. என்னென்ன நன்மைகள் கிடைக்கும்?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% கமிஷன் (100% இலவசம்) — இடைத்தரகர் இல்லை.\n• வாடிக்கையாளர்களிடமிருந்து நேரடியாக WhatsApp மற்றும் அழைப்பில் ஆர்டர்களைப் பெறுங்கள்.\n• 24 மணி நேரமும் திறந்திருக்கும் டிஜிட்டல் கடை.',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'புரிந்தது, நன்றி 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-கிளிக்கில் முழு முகவரியையும் தானாக நிரப்பவும்',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS மூலம் மாநிலம், மாவட்டம், பகுதி, பின்கோடு தானாக நிரப்பப்படும்',
  [LangKeys.biz_profile__autofill_searching]: 'இடம் கண்டறியப்படுகிறது...',
  [LangKeys.biz_profile__state_lbl]: 'மாநிலம் (State)',
  [LangKeys.biz_profile__state_add]: 'மாநிலத்தைச் சேர்க்கவும்',
  [LangKeys.biz_profile__state_placeholder]: 'எ.கா. Tamil Nadu, Kerala, Karnataka...',
  [LangKeys.biz_profile__city_lbl]: 'நகரம் / மாவட்டம் (City / District)',
  [LangKeys.biz_profile__city_add]: 'நகரத்தைச் சேர்க்கவும்',
  [LangKeys.biz_profile__city_placeholder]: 'எ.கா. Chennai, Coimbatore, Madurai...',
  [LangKeys.biz_profile__area_lbl]: 'பகுதி / கிராமம் (Area / Village)',
  [LangKeys.biz_profile__area_add]: 'பகுதியைச் சேர்க்கவும்',
  [LangKeys.biz_profile__area_placeholder]: 'எ.கா. T Nagar, Anna Nagar, Gandhipuram...',
  [LangKeys.biz_profile__pincode_lbl]: 'பின்கோடு (Pincode)',
  [LangKeys.biz_profile__pincode_add]: 'பின்கோடைச் சேர்க்கவும்',
  [LangKeys.biz_profile__pincode_placeholder]: '6 இலக்க பின்கோடை உள்ளிடவும்',
  [LangKeys.biz_profile__tagline_lbl]: 'வணிக வாசகம் / விளக்கம்',
  [LangKeys.biz_profile__tagline_add]: 'வாசகத்தைச் சேர்க்கவும்',
  [LangKeys.biz_profile__tagline_placeholder]: 'எ.கா. எங்களிடம் புதிய தரமான பொருட்கள் கிடைக்கும்',
  [LangKeys.biz_profile__gps_lbl]: 'வணிக GPS இருப்பிடம்',
  [LangKeys.biz_profile__gps_not_set]: 'இருப்பிடம் இன்னும் அமைக்கப்படவில்லை',
  [LangKeys.biz_profile__gps_update_btn]: 'புதுப்பிக்கவும்',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS இருப்பிடத்தைப் பெறவும்',
  [LangKeys.biz_profile__gps_searching]: 'தேடுகிறது...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ ஸ்டோர் ஆன்லைனில் உள்ளது ஆனால் GPS அமைக்கப்படவில்லை! வாடிக்கையாளர்களுக்கு கடை தெரிய ⚡ 1-கிளிக் மூலம் GPS அமைக்கவும்.',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'உலாவியில் GPS / Location-ஐ இயக்கவும்',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'இருப்பிட அனுமதி மறுக்கப்பட்டது',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'அமைப்புகளில் Location Permission-ஐ இயக்கவும்',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS மூலம் முழு முகவரியும் தானாக நிரப்பப்பட்டது!',
  [LangKeys.biz_profile__gps_error_toast]: 'இருப்பிடத்தைப் பெறுவதில் பிழை',
  [LangKeys.biz_market_video_guide_title]: 'உள்ளூர் சந்தையில் கடையை ஆன்லைனில் கொண்டு வருவது எப்படி?',
  [LangKeys.biz_market_video_guide_sub]: '1 நிமிட வீடியோ வழிகாட்டியைப் பார்க்கவும் • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "ஸ்டோர் மற்றும் தயாரிப்புகளை ஆன்லைனில் செயல்படுத்த வழிகாட்டி",
  [LangKeys.service_video_guide_btn_sub]: "வேலை மற்றும் கடையை ஆன்லைனில் பட்டியலிட வழிகாட்டி",
  [LangKeys.item_marketplace_title]: "ஆன்லைன் சந்தை (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "இந்த தயாரிப்பு வாடிக்கையாளர்களுக்கு ஆன்லைனில் தெரியும், அவர்கள் உங்களை நேரடியாக தொடர்புகொள்ளலாம் மற்றும் வாட்ஸ்அப்பில் ஆர்டர் செய்யலாம்.",
  [LangKeys.item_marketplace_sub_inactive]: "இந்த தயாரிப்பு உங்கள் தனிப்பட்ட கணக்கில் மட்டுமே இருக்கும்.",
  [LangKeys.service_marketplace_sub_active]: "இந்த சேவை வாடிக்கையாளர்களுக்கு ஆன்லைனில் தெரியும், அவர்கள் உங்களை நேரடியாக தொடர்புகொள்ளலாம் மற்றும் வாட்ஸ்அப்/அழைப்பில் புக் செய்யலாம்.",
  [LangKeys.service_marketplace_sub_inactive]: "இந்த சேவை உங்கள் கடையின் தனிப்பட்ட கணக்கில் மட்டுமே இருக்கும்.",
  [LangKeys.item_category_lbl]: "வகை (Category)",
  [LangKeys.change_btn]: "மாற்று",
  [LangKeys.item_discount_price_lbl]: "தள்ளுபடி விலை (₹) (Optional)",
  [LangKeys.item_discount_price_hint]: "எ.கா. 450",
  [LangKeys.service_discount_price_lbl]: "தள்ளுபடி கட்டணம் (₹) (Optional)",
  [LangKeys.service_discount_price_hint]: "எ.கா. 750",
  [LangKeys.item_desc_lbl]: "விவரம் (Optional)",
  [LangKeys.item_desc_hint]: "தயாரிப்பு பிராண்ட், மாடல், நிறம், அளவு மற்றும் முக்கிய அம்சங்களை உள்ளிடவும்...",
  [LangKeys.service_desc_lbl]: "சேவை விவரம் (Optional)",
  [LangKeys.service_desc_hint]: "சேவையின் முக்கிய அம்சங்கள், பணி செயல்முறை மற்றும் அனுபவத்தை உள்ளிடவும்...",
  [LangKeys.market_seo_badge]: "கூகிள் தேடல் & தரவரிசை",
  [LangKeys.category_picker_title]: "வகை தேர்வு",
  [LangKeys.category_picker_sub_item]: "பொருள் எந்த வகையைச் சேர்ந்தது?",
  [LangKeys.category_picker_sub_service]: "சேவை எந்த வகையைச் சேர்ந்தது?",
  [LangKeys.category_search_hint]: "வகையைத் தேடுங்கள் (எ.கா. மளிகை, பால், உடைகள்...)",
  [LangKeys.no_category_found]: "வகை எதுவும் கிடைக்கவில்லை",
  [LangKeys.nothing_found_for]: "இதற்கு எதுவும் கிடைக்கவில்லை",
  [LangKeys.cat_title_general]: "பொதுவான பொருட்கள்",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "மளிகை பொருட்கள்",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "பால் & நெய்",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "பழங்கள் & காய்கறி",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "இனிப்பு & பேக்கரி",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "உணவகம் & ஹோட்டல்",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "மருந்தகம் & மெடிக்கல்",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "விவசாயம் & உரம்",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "கால்நடை தீவனம்",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "மொபைல் & எலக்ட்ரானிக்ஸ்",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "மின்சாதனங்கள்",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "துணிகள் & ஆடைகள்",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "காலணிகள்",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "ஹார்டுவேர் & சானிட்டரி",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "கட்டுமான பொருட்கள்",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "வாகன உதிரிபாகங்கள்",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "அழகுசாதனம் & சலூன்",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "புத்தகம் & ஸ்டேஷனரி",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "நகைகள் & ஜுவல்லரி",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "மரச்சாமான்கள் & ஃபர்னிச்சர்",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "பாத்திரங்கள்",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "பொம்மை & விளையாட்டு",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "பேக்கேஜிங் பொருட்கள்",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "தையல் & பூட்டிக்",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "இறைச்சி & மீன்",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "பழுதுபார்ப்பு & சர்வீஸ்",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "பிற பொருட்கள் & சேவைகள்",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "கண்ணாடி மற்றும் ஆப்டிகல்ஸ்",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "பூஜை பொருட்கள் & ஊதுபத்தி",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "கடிகாரங்கள் மற்றும் பாகங்கள்",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "பொதுவான சேவை",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "டிவி & எலக்ட்ரானிக்ஸ்",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "ஏசி & பிரிட்ஜ் ரிப்பேர்",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "எலக்ட்ரீஷியன் & வயரிங்",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "பிளம்பர் & சானிட்டரி",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "தையல் & ஆடைகள்",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "மொபைல் & லேப்டாப் சர்வீஸ்",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "வாகன மெக்கானிக் & வாஷ்",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "பியூட்டி பார்லர் & சலூன்",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "தச்சர் / கார்பெண்டர்",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "பெயிண்டிங் வேலை",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "கட்டுமான மேஸ்திரி",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "டிராக்டர் & மோட்டார்",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "CCTV கேமரா",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "சுத்தம் & பெஸ்ட் கன்ட்ரோல்",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "போக்குவரத்து & லோடிங்",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "புகைப்படம் & வீடியோ",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "கேட்டரிங் & டென்ட்",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "டியூஷன் & கல்வி",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "வரி & E-Mitra மையம்",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "டாக்டர் & கிளினிக்",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "பிற சேவைகள்",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "டாக்ஸி மற்றும் டூர் டிராவல்ஸ்",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "வழக்கறிஞர் மற்றும் சட்ட ஆலோசனை",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "பேக்கர்ஸ் அண்ட் மூவர்ஸ்",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "பிரிண்டிங் & ஃப்ளெக்ஸ் பேனர்",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "ஜிம், உடற்பயிற்சி & யோகா",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "சமையல் & வீட்டு வேலை ஆட்கள்",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "புகைப்படம் சேர்க்கப்பட்டது • Tier-1 சிறந்த பட்டியல்",
  [LangKeys.item_photo_guide_why_add]: "புகைப்படம் ஏன் சேர்க்க வேண்டும்? (5x கூடுதல் விற்பனை)",
  [LangKeys.service_photo_guide_why_add]: "புகைப்படம் ஏன் சேர்க்க வேண்டும்? (5x கூடுதல் முன்பதிவு)",
  [LangKeys.item_photo_guide_desc]: "தெளிவான PNG/JPG புகைப்படங்களைச் சேர்க்கவும். புகைப்படங்கள் உள்ள தயாரிப்புகள் உள்ளூர் சந்தையில் முதலிடத்தில் (Tier-1) தோன்றும்.",
  [LangKeys.service_photo_guide_desc]: "உங்கள் வேலை, கருவிகள் அல்லது கடையின் தெளிவான புகைப்படங்களைச் சேர்க்கவும். புகைப்படங்கள் உள்ள சேவைகள் அருகில் உள்ள வாடிக்கையாளர்களுக்கு முதலிடத்தில் (Tier-1) தோன்றும்.",
  [LangKeys.item_video_guide_btn_title]: "ஆன்லைன் பட்டியலைக் கற்றுக்கொள்ளுங்கள் (5 நிமிட வீடியோ)",
  [LangKeys.service_video_guide_btn_title]: "சேவை பட்டியலைக் கற்றுக்கொள்ளுங்கள் (5 நிமிட வீடியோ)",
  [LangKeys.market_format_bold]: "𝗕 தடித்த எழுத்து (*பெயர்*)",
  [LangKeys.market_format_bullet]: "• புல்லட் புள்ளி",
  [LangKeys.market_format_highlight]: "⭐ முக்கிய சிறப்பம்சங்கள்",
  [LangKeys.market_format_warranty_item]: "📦 உத்தரவாதம் / விவரங்கள்",
  [LangKeys.market_format_warranty_service]: "📦 உத்தரவாதம் / கேரண்டி",
  [LangKeys.market_format_template_item]: "⚡ மாதிரி டெம்ப்ளேட்",
  [LangKeys.market_format_template_service]: "⚡ சேவை டெம்ப்ளேட்",
  [LangKeys.market_seo_tip_item]: "விரிவான விளக்கம் எழுதுவது கூகிள் தேடலிலும் ஆன்லைன் சந்தையிலும் தயாரிப்பை விரைவாகக் காண்பிக்க உதவும்.",
  [LangKeys.market_seo_tip_service]: "விரிவான விளக்கம் எழுதுவது கூகிள் தேடலிலும் ஆன்லைன் சந்தையிலும் சேவையை விரைவாகக் காண்பிக்க உதவும்.",
  [LangKeys.crop_photo_title]: "புகைப்படத்தை கிராப் & சரிசெய்யவும்",
  [LangKeys.crop_product_photo]: "தயாரிப்பு புகைப்படத்தை கிராப் செய்யவும்",
  [LangKeys.crop_service_photo]: "சேவை புகைப்படத்தை கிராப் செய்யவும்",
  [LangKeys.crop_drag_hint]: "படத்தை நகர்த்த இழுக்கவும்",
  [LangKeys.crop_rotate_left]: "90° இடது",
  [LangKeys.crop_rotate_right]: "90° வலது",
  [LangKeys.crop_reset]: "மீட்டமை",
  [LangKeys.crop_ratio_square]: "1:1 (சதுரம்)",
  [LangKeys.crop_ratio_standard]: "4:3 (நிலையானது)",
  [LangKeys.crop_ratio_free]: "Free (தனிப்பயன்)",
  [LangKeys.crop_save_done]: "கிராப் செய்து சேமி (Done)",
  [LangKeys.crop_compressing]: "சுருக்கப்படுகிறது...",
  [LangKeys.party_or_details]: "பார்ட்டி / விவரங்கள்",
  [LangKeys.report_copied_clipboard]: "அறிக்கை சுருக்கம் கிளிப்போர்டில் நகலெடுக்கப்பட்டது!",
  [LangKeys.party]: "பார்ட்டி",
  [LangKeys.sale]: "விற்பனை",
  [LangKeys.purchase]: "கொள்முதல்",
  [LangKeys.expense]: "செலவு",
  [LangKeys.ai_support_btn]: "AI ஆதரவுடன் அரட்டையடிக்கவும் (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI ஆதரவு",
  [LangKeys.ai_support_online_status]: "● 24x7 உடனடி ஆதரவு",
  [LangKeys.ai_support_welcome_msg]: "வணக்கம்! 🙏 நான் *Moxpal Khata* வின் ஸ்மார்ட் AI உதவியாளர்.\\n\\nஉங்கள் கணக்கு, பில்லிங், பால் பண்ணை பாஸ்புக் அல்லது சந்தா திட்டம் தொடர்பான அனைத்து கேள்விகளுக்கும் உதவ நான் தயாராக உள்ளேன். நீங்கள் என்ன தெரிந்து கொள்ள விரும்புகிறீர்கள்?",
  [LangKeys.ai_support_input_hint]: "உங்கள் கேள்வி அல்லது சிக்கலை இங்கே கேட்கவும்...",
  [LangKeys.ai_support_typing]: "AI உதவியாளர் பதிலளிக்கிறார்...",
  [LangKeys.ai_support_copied]: "செய்தி நகலெடுக்கப்பட்டது",
  [LangKeys.ai_support_net_error]: "இணைய இணைப்பில் சிக்கல் உள்ளது. நெட்வொர்க்கை சரிபார்க்கவும்.",
  [LangKeys.ai_support_server_error]: "சேவையகத்துடன் இணைப்பதில் சிக்கல் ஏற்பட்டது. மீண்டும் முயற்சிக்கவும் அல்லது WhatsApp-ல் தொடர்பு கொள்ளவும்.",
  [LangKeys.ai_support_sugg_plan]: "💎 திட்டத்தின் நன்மைகள் என்ன?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 பால் பண்ணை பாஸ்புக்கை எப்படி பயன்படுத்துவது?",
  [LangKeys.ai_support_sugg_party]: "👥 புதிய வாடிக்கையாளர்/கணக்கை எவ்வாறு சேர்ப்பது?",
  [LangKeys.ai_support_sugg_backup]: "💾 தரவை எவ்வாறு காப்புப் பிரதி எடுப்பது?",
  [LangKeys.ai_support_sugg_bill]: "🧾 புதிய பில்லை எவ்வாறு உருவாக்குவது?",
  [LangKeys.ai_support_clear_chat]: "புதிய உரையாடலைத் தொடங்குங்கள்",
  [LangKeys.ai_support_clear_title]: "அரட்டை வரலாற்றை அழிக்கவா?",
  [LangKeys.ai_support_clear_confirm]: "பழைய உரையாடலை அழித்து புதிய அரட்டையைத் தொடங்க விரும்புகிறீர்களா?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "அடிக்கடி கேட்கப்படும் கேள்விகள் மற்றும் வாடிக்கையாளர் ஆதரவு மையம்",
  [LangKeys.help_support_title]: "உதவி மற்றும் ஆதரவு",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "கேள்விகள், பயிற்சிகள் மற்றும் வாடிக்கையாளர் ஆதரவுக்கான உங்கள் ஒரே இடம்",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 உடனடி ஆதரவு",
  [LangKeys.help_ai_desc]: "கணக்கு, பில்லிங், சரக்கு, பால் பாஸ்புக் அல்லது திட்டங்கள் தொடர்பான அனைத்து கேள்விகளுக்கும் உடனடி AI தீர்வு பெறுங்கள்.",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • அதிகாரப்பூர்வ ஆதரவு குழு",
  [LangKeys.help_call_title]: "அழைப்பு உதவி எண்",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "மின்னஞ்சல் ஆதரவு",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "அடிக்கடி கேட்கப்படும் கேள்விகள் (FAQs)",
  [LangKeys.help_faq_1_q]: "கத்தாவில் புதிய வாடிக்கையாளர் அல்லது சப்ளையரை எவ்வாறு சேர்ப்பது?",
  [LangKeys.help_faq_1_a]: "முகப்புத் திரையில் \"Add Customer\" பொத்தானைத் தட்டவும், பெயர் மற்றும் மொபைல் எண்ணை உள்ளிட்டு சேமிக்கவும்.",
  [LangKeys.help_faq_2_q]: "பால் பாஸ்புக்கில் பால் சேகரிப்பை எவ்வாறு பதிவு செய்வது?",
  [LangKeys.help_faq_2_a]: "பால் பிரிவிற்குச் சென்று, \"பால் பதிவு\" என்பதைத் தேர்ந்தெடுத்து, கொழுப்பு/SNF அல்லது நேரடி விலையை உள்ளிட்டு 1-கிளிக்கில் ரசீது அனுப்பவும்.",
  [LangKeys.help_faq_3_q]: "தரவு காப்புப்பிரதி எவ்வாறு பாதுகாப்பாக வைக்கப்படுகிறது?",
  [LangKeys.help_faq_3_a]: "Moxpal Khata வில் உங்கள் அனைத்து தரவுகளும் கிளவுட் சர்வரில் 100% குறியாக்கம் செய்யப்பட்டு பாதுகாப்பாக வைக்கப்பட்டுள்ளன.",
  [LangKeys.help_faq_4_q]: "சந்தா திட்டத்தை எவ்வாறு மேம்படுத்துவது?",
  [LangKeys.help_faq_4_a]: "அமைப்புகளில் \"எனது சந்தா\" என்பதற்குச் சென்று உங்களுக்கு விருப்பமான திட்டத்தைத் தேர்ந்தெடுத்து பாதுகாப்பான கட்டணம் செலுத்தவும்.",
  [LangKeys.help_footer_call_hours]: "அழைப்பு ஆதரவு: திங்கள் - சனி (காலை 9:00 முதல் இரவு 8:00 வரை)",
  [LangKeys.help_footer_ai_hours]: "AI அரட்டை உதவியாளர்: 24 மணி நேரமும் 365 நாட்களும் உடனடி உதவி",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% பாதுகாப்பானது மற்றும் நம்பகமானது • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "சேவையைத் திறக்க முடியவில்லை",
};

export default ta;